// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-06T21:26:26.489Z
// Property: Hangar at Bergstrom (ID: 6767906449167663)
// Collections: 69 amenities, 13 floorplans (live), 25 photos, 76 POIs, 3 reviews, 1 virtual tours, 6 office hours, 2 special offers (live), 5 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162466",
  "multihub_property_id": "6767906449167663",
  "property_external_id": "2180500",
  "property_zillow_url": "https://www.zillow.com/apartments/austin-tx/hangar-at-bergstrom/ChCj6k/",
  "property_apartments_url": "https://www.apartments.com/hangar-at-bergstrom-austin-tx/nbnykgm/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Hangar+at+Bergstrom+Apartments/@30.1860493,-97.7005326,989m/data=!3m2!1e3!4b1!4m6!3m5!1s0x8644b18eaa265b7f:0x3f0f113be7529868!8m2!3d30.1860493!4d-97.7005326!16s%2Fg%2F11txmyv2d9?entry=ttu&g_ep=EgoyMDI2MDgxNy4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "57313859383",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "2180500\np2147694",
  "property_status": null,
  "property_slug": "hangar-at-bergstrom",
  "property_name": "Hangar at Bergstrom",
  "property_website_url": "https://www.thehangaratbergstrom.com",
  "property_domain": "https://www.thehangaratbergstrom.com",
  "property_address": "7733 Burleson Rd",
  "property_full_address": "7733 Burleson Rd, Austin, TX 78744",
  "property_address_1": "7733 Burleson Rd",
  "property_address_2": null,
  "property_address_city": "Austin",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "78744",
  "property_address_country": "US",
  "property_address_county": "Travis County",
  "property_neighborhood_address": "Southeast Austin",
  "property_address_latitude": "30.1852229",
  "property_address_longitude": "-97.7015547",
  "property_email": "chbManager@mox.living",
  "property_phone": "(512) 967-6509",
  "property_call_tracking_phone": "512-967-6509",
  "property_company_name": "Mox",
  "property_company_url": "https://www.mox.living/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Modern Southeast Austin living with room to land.</strong> Hangar at Bergstrom brings aviation-inspired style to polished one- and two-bedroom apartments with contemporary finishes, smart everyday conveniences, and community spaces built for work-to-downtime ease. Explore <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> today.</p>",
  "property_long_description": "The Hangar at BergstromUpscale Apartments in Austin, TXWelcome to The Hangar at Bergstrom (formerly known as Citizen House Bergstrom), where sophisticated Austin, TX apartments meet the vibrant energy of Southeast Austin. Our upscale community redefines modern apartment living with one and two-bedroom residences featuring designer interiors, premium finishes, and an elevated, aviation-inspired atmosphere that feels like home from day one. Located just minutes from Austin-Bergstrom International Airport and the natural beauty of McKinney Falls State Park, these apartments in Austin, TX offer the perfect blend of urban convenience and serene surroundings.Every detail at The Hangar at Bergstrom has been thoughtfully curated to elevate your lifestyle. From gourmet kitchens with quartz countertops and stainless steel appliances to expansive walk-in closets and in-unit washers and dryers, our Austin apartments provide the luxury and functionality you deserve. Step outside your door to discover resort-style amenities including a sparkling pool, state-of-the-art fitness center, dedicated co-working spaces, and a vibrant dog park. Whether you're commuting downtown, exploring local dining hotspots, or enjoying weekend adventures at nearby attractions, you'll find that life at The Hangar at Bergstrom puts everything Austin has to offer right at your fingertips.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1b-3681-7639-adcb-246e7e6737be.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor lounge area with pool and lounge chairs in the background.",
    "public_id": "019ffd1b-3681-7639-adcb-246e7e6737be",
    "storage_key": "property/6767906449167663/019ffd1b-3681-7639-adcb-246e7e6737be.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "414",
  "property_year_built": "2023",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "82.1256038647343",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "0",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "We are proud partners with PetScreening.com! Pet rents range; please contact the office for details on rents and size/breed restrictions.",
  "property_pet_policy_description": "We understand that pets are part of the family. That's why your pets are welcome to join our community.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://thehangaratbergstrom.securecafeapplicant.com/onlineleasing/content3/access/the-hangar-at-bergstrom/login",
  "property_resident_portal_url": "https://thehangaratbergstrom.securecafenet.com/residentservices/the-hangar-at-bergstrom/userlogin",
  "property_apply_now_url": "https://thehangaratbergstrom.securecafeapplicant.com/onlineleasing/content3/access/the-hangar-at-bergstrom/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a0211f-ea2b-7565-8a56-8529f37d7bb4.webp",
  "property_primary_logo_media": {
    "alt_text": "The Hangar at Bergstrom logo.",
    "public_id": "01a0211f-ea2b-7565-8a56-8529f37d7bb4",
    "storage_key": "property/6767906449167663/01a0211f-ea2b-7565-8a56-8529f37d7bb4.webp",
    "width": 1200,
    "height": 548
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1c-0a40-7177-a2f4-d360198c1192.webp",
  "property_secondary_logo_media": {
    "alt_text": "The letter H with wings logo.",
    "public_id": "019ffd1c-0a40-7177-a2f4-d360198c1192",
    "storage_key": "property/6767906449167663/019ffd1c-0a40-7177-a2f4-d360198c1192.webp",
    "width": 764,
    "height": 418
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a02120-7c69-7256-9aa9-96e8b2e6df0c.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a02120-7c69-7256-9aa9-96e8b2e6df0c",
    "storage_key": "property/6767906449167663/01a02120-7c69-7256-9aa9-96e8b2e6df0c.webp",
    "width": 1200,
    "height": 548
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a02120-715a-766a-923a-c179e41dc749.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a02120-715a-766a-923a-c179e41dc749",
    "storage_key": "property/6767906449167663/01a02120-715a-766a-923a-c179e41dc749.webp",
    "width": 1200,
    "height": 548
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162466/01a0b110-11a0-73bb-ba59-e09d0fa98a78.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162466/01a0105a-2d11-75c8-b1a7-2269011410e5.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162466/01a0b10f-c4d1-77d8-b6d1-8c4ee1490c37.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162466/01a0105a-2d11-75c8-b1a7-2269011410e5.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002856",
  "property_secondary_color": "#939598",
  "property_font_color": "#000000",
  "property_color_4": "#496186",
  "property_color_3": "#636569",
  "property_color_5": "#bcbec0",
  "property_color_6": "#bdbfc1",
  "property_color_7": "#94a1b8",
  "property_color_8": "#d1d3d4",
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "650 - 1264",
  "property_sqft_min": "650",
  "property_sqft_max": "1264",
  "property_price_range": "1189 - 3323",
  "property_price_min": "1189",
  "property_price_max": "3323",
  "property_available_units": 75,
  "property_facebook_url": "https://www.facebook.com/thehangaratbergstrom/",
  "property_instagram_url": "https://www.instagram.com/thehangaratbergstrom/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJf1smqo6xRIYRaJhS5zsRDz8",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Hangar at Bergstrom",
  "property_home_romance_title": "Create Cherished Memories in Your Perfect Apartment Home",
  "property_home_amenities_blurb": "<p><strong>Polished spaces, practical perks.</strong> Hangar at Bergstrom keeps daily routines simple with air conditioning, ceiling fans, reliable appliances, and easy-to-settle-into layouts. Step outside for a refreshing swim, open gathering areas, work-friendly spaces, fitness options, package lockers, EV charging, and pet-friendly outdoor features—all designed to add comfort and convenience in Southeast Austin.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find your fit at Hangar at Bergstrom.</strong> Choose from streamlined one-bedroom layouts and spacious two-bedroom, two-bath homes with open living areas, modern kitchens, walk-in closets, and in-home laundry connections. Select floor plans add standout touches like a patio or balcony, dual vanity, garden tub, or fenced yard—giving each home its own practical edge.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a first look at Hangar at Bergstrom’s polished Austin style.</strong> Browse bright one- and two-bedroom interiors with wood-look flooring, quartz-style counters, stainless steel appliances, and warm pendant lighting, then preview the pool, grilling areas, clubhouse, fitness center, and open-air seating. Aviation-inspired details and green-view moments give the gallery a sense of place worth seeing in full.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Green space, local flavor, easy connections.</strong> Hangar at Bergstrom places you on Austin’s Bluff Springs side, close to McKinney Falls State Park trails, creekside views, Meanwhile Brewing, and Live Oak Brewing. Burleson Road keeps Highway 71, US 183, Southpark Meadows, and South Austin dining within easy reach. Explore the map, then see how this Southeast Austin location fits your day.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents highlight service that follows through.</strong> Reviews for Hangar at Bergstrom call out friendly, welcoming staff, helpful management, and maintenance teams known for prompt, respectful work done right. Clean, well-kept homes and a calm, comfortable atmosphere come up often, along with tour experiences that feel clear and supported from the start. Read the reviews to see what makes this Austin community easy to come home to.</p>",
  "property_neighborhood_blurb": "<p><strong>Let the neighborhood set the pace.</strong> From Hangar at Bergstrom, you’re on the Bluff Springs side of Austin, where open green space, airport-area convenience, and the growing Southeast dining scene all sit within easy reach. Spend off-hours on the limestone trails and creekside views at McKinney Falls State Park, meet up over food trucks and live music at Meanwhile Brewing, or head toward Live Oak Brewing for an easy biergarten stop.</p><p>Everyday plans stay simple, too, with Burleson Road connecting you to Highway 71, US 183, Southpark Meadows shopping, and more of South Austin’s restaurants and entertainment. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how this location fits your routine.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that keep your day moving.</strong> At Hangar at Bergstrom, everyday comfort starts with polished spaces and practical details: cool air conditioning, ceiling fans, a reliable refrigerator, and layouts that make it easy to settle in. Beyond your front door, the swimming pool gives you a refreshing place to reset, while modern community conveniences add ease to the routine.</p><p>From contemporary finishes and open gathering areas to work-friendly spaces, fitness options, package lockers, EV charging, and pet-friendly outdoor features, this Southeast Austin community is designed to support the way you move through the day. Browse the <a href=\"/gallery\">photo gallery</a> for a closer look, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to land at Hangar at Bergstrom?</strong> Start your online application for modern Southeast Austin living with one- and two-bedroom floor plans, contemporary kitchens, walk-in closets, in-home laundry, and select private outdoor spaces—plus everyday ease designed to keep workdays and downtime moving smoothly.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Contact the Hangar at Bergstrom leasing team for help exploring modern Southeast Austin apartment living, from one- and two-bedroom floor plans to aviation-inspired style and everyday conveniences. We’re here to make your next step simple.</p>",
  "property_faqs_blurb": "<p><strong>Questions before you land?</strong> Find quick answers about Hangar at Bergstrom’s apartment features, community spaces, leasing details, and everyday living in Southeast Austin. If you need more information, the leasing team is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the layout that fits your day.</strong> Hangar at Bergstrom gives you a focused collection of one- and two-bedroom apartment homes, from efficient one-bedroom retreats to larger two-bedroom, two-bath designs with room to spread out. Inside, open living areas, modern kitchens, walk-in closets, and in-home laundry connections help every floor plan feel practical from the start.</p><p>Look for details that make the difference: quartz-style surfaces, stainless steel appliances, ceiling fans, wood-look flooring in shared spaces, and select homes with a patio, balcony, dual vanity, garden tub, or fenced yard. Browse current availability, compare layouts side by side, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see which home at Hangar at Bergstrom feels right in person.</p>",
  "property_gallery_blurb": "<p><strong>Preview the details that make Hangar at Bergstrom feel polished from the first glance.</strong> As you move through the gallery, picture bright one- and two-bedroom interiors with wood-look flooring, clean white walls, ceiling fans, and kitchens framed by white cabinetry, quartz-style counters, stainless steel appliances, and warm pendant lighting. Community photos shift the scene outdoors to the pool’s lounging edge, grilling spaces, and open-air seating, then inside to the fitness center, clubhouse, and work-friendly areas. You’ll also catch the aviation-inspired identity and green-view moments that give this Austin community its own sense of place. Browse the photos, explore <a href=\"/virtual-tours\">virtual tours</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Map your next move.</strong> Explore available apartments at Hangar at Bergstrom and see how this Southeast Austin address connects polished home features with nearby nature, travel access, dining, music, and entertainment. Use the interactive map to get a feel for what’s close—and what fits your day.</p>",
  "property_pets_blurb": "<p><strong>Bring the routine you share with your pets.</strong> At Hangar at Bergstrom, pet-friendly living is built around easy exits, fresh-air breaks, and spaces that help everyday care feel simpler. Take your dog to the on-site dog park, head out for a walk on community-connected nature trails, or look for select layouts with fenced yards when a little extra outdoor convenience matters.</p><p>Cats get comfort, too, with bright, climate-controlled interiors, ceiling fans, and room to curl up after a sunny Austin afternoon. Review the pet guidelines shown here, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Hangar at Bergstrom fits the way you and your pets move through the day.</p>",
  "property_referafriend_blurb": "<p><strong>Share the place that gives everyday living room to land.</strong> Invite friends to Hangar at Bergstrom, where modern one- and two-bedroom homes, elevated aviation-inspired style, and easy work-to-downtime spaces make Southeast Austin living feel polished, practical, and connected.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, cleared for ease.</strong> From Hangar at Bergstrom, manage everyday apartment needs in just a few clicks. Pay rent, submit maintenance requests, and keep your account up to date—so you can get back to the polished Southeast Austin living waiting beyond your door.</p>",
  "property_reviews_blurb": "<p><strong>See what residents are saying about Hangar at Bergstrom.</strong> Reviews point to a community experience shaped by attentive service, well-kept spaces, and a team that follows through. Residents call the staff and management “friendly, welcoming, and helpful,” while maintenance gets standout praise for prompt, respectful work and getting requests “completed the right way.”</p><p>You’ll also find feedback from residents who have enjoyed clean, well-maintained homes and a calm, comfortable atmosphere, plus tour guests who felt informed and supported from the first visit. Browse the reviews below to hear firsthand what makes Hangar at Bergstrom feel easy to come home to.</p>",
  "property_created_at": "1786657756383",
  "property_scheduletour_blurb": "<p><strong>See Hangar at Bergstrom up close.</strong> Tour aviation-inspired one- and two-bedroom apartments with contemporary kitchens, walk-in closets, in-home laundry, and select private outdoor spaces—then explore the everyday ease waiting beyond your front door. Schedule your visit today and picture your next landing spot.</p>",
  "property_thankyou_blurb": "<p><strong>Thanks for reaching out.</strong> Your inquiry has been received, and the leasing team will follow up soon. In the meantime, picture modern Southeast Austin living with aviation-inspired style, polished one- and two-bedroom homes, and easy ways to move from workday to downtime right outside your door.</p>",
  "property_virtualtours_blurb": "<p><strong>Start at the front door, wherever you are.</strong> The Entrance virtual tour gives you a first look at the arrival experience at Hangar at Bergstrom, from the community’s polished exterior presence to the sense of access and design that sets the tone before you step inside. Take a moment to orient yourself, picture the daily in-and-out rhythm, and see how this Southeast Austin address presents itself from the curb.</p><p>Use the tour as your starting point, then continue exploring with the <a href=\"/gallery\">photo gallery</a>, compare available <a href=\"/floor-plans\">one- and two-bedroom layouts</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> for a closer look at the spaces that matter most to your search.</p>",
  "property_copyright": "2026 All Rights Reserved. Hangar at Bergstrom",
  "property_seo_title_home": "Hangar at Bergstrom |  Apartments in Austin, TX",
  "property_seo_description_home": "Elevate your lifestyle at Hangar at Bergstrom in Austin, TX! Enjoy spacious floor plans, a refreshing pool, and modern comforts. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Austin, TX Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Hangar at Bergstrom in Austin, TX. Choose from stylish one or two-bedroom floor plans that fit your lifestyle. Browse today!",
  "property_seo_title_amenities": "Amenities | Austin, TX Apartments for Rent",
  "property_seo_description_amenities": "Dive into comfort at Hangar at Bergstrom, Austin! Enjoy our refreshing pool, modern kitchens, and cozy living spaces. Your ideal home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Austin, TX",
  "property_seo_description_gallery": "Discover modern living at Hangar at Bergstrom, Austin, TX! Enjoy vibrant amenities, stunning pools, and stylish floor plans. Envision your life here!",
  "property_seo_title_virtualtours": "Virtual Tours | Hangar at Bergstrom Apartments",
  "property_seo_description_virtualtours": "Step into your future home at Hangar at Bergstrom! Check out our one and two-bedroom apartments in Austin, TX. Take a virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | Hangar at Bergstrom Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Hangar at Bergstrom in Austin, TX! Use our interactive map to explore one and two-bedroom apartments with top-notch amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Austin, TX",
  "property_seo_description_neighborhood": "Experience the vibrant neighborhood at Hangar at Bergstrom, Austin, TX. Uncover local favorites and attractions just steps from your doorstep.",
  "property_seo_title_contact": "Contact Us | Hangar at Bergstrom",
  "property_seo_description_contact": "Reach out to the Hangar at Bergstrom in Austin, TX! Explore our one and two-bedroom floor plans and connect with our leasing team for any inquiries.",
  "property_seo_title_faqs": "FAQs | Apartments in Austin, TX",
  "property_seo_description_faqs": "Find answers to your questions about Hangar at Bergstrom in Austin, TX! Dive into our FAQs about one and two-bedroom plans and top-notch amenities!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Austin, TX",
  "property_seo_description_reviews": "Discover life at Hangar at Bergstrom! Explore resident insights and see why our one & two-bedroom apartments with pools stand out in Austin, TX!",
  "property_seo_title_applynow": "Apply Now | Apartments in Austin, TX",
  "property_seo_description_applynow": "Lease your dream space at Hangar at Bergstrom in Austin, TX. Enjoy refreshing amenities like a pool, AC, and stylish floor plans. Your new home awaits!",
  "property_seo_title_residentaccess": "Resident Access | Hangar at Bergstrom",
  "property_seo_description_residentaccess": "Unlock your Hangar at Bergstrom experience! Manage rent, schedule maintenance, and connect with neighbors effortlessly through your resident portal.",
  "property_seo_title_referafriend": "Refer A Friend | Hangar at Bergstrom",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Hangar at Bergstrom in Austin, TX, and enjoy community perks together. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Hangar at Bergstrom",
  "property_seo_description_scheduletour": "Experience the charm of Hangar at Bergstrom in Austin, TX! Schedule your tour today and see why our vibrant community is your perfect new home.",
  "property_seo_title_privacy": "Privacy Policy | Hangar at Bergstrom",
  "property_seo_description_privacy": "Your privacy matters at Hangar at Bergstrom. Learn how we protect your information while you enjoy vibrant Austin living. Read our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Hangar at Bergstrom",
  "property_seo_description_accessibility": "At Hangar at Bergstrom in Austin, TX, we promote digital inclusion and prioritize accessibility for a comfortable living experience for all.",
  "property_seo_title_sitemap": "Sitemap | Hangar at Bergstrom",
  "property_seo_description_sitemap": "Navigate your way through The Hangar at Bergstrom! Check our sitemap for easy access to stunning apartments and community amenities in vibrant Austin, TX.",
  "property_seo_title_thankyou": "Thank You | Hangar at Bergstrom",
  "property_seo_description_thankyou": "Thank you for your interest in Hangar at Bergstrom! Our team will reach out soon to help you discover your ideal Austin living experience. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Austin, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791321174678",
  "amenities": [
    {
      "id": "ec_6b0abe4f4d620669848b77d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127913479",
      "title": "Housekeeping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ffd2083b525ee8fb48e96613",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127913478",
      "title": "Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_683074278a713ceb4922c324",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127898207",
      "title": "Carport",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c6bf220dca8f27f5f9f7100a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127898208",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_228aa06a24b2e8b6ecc7f193",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127898209",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa68faac16b7f62604cf9304",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883558",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bf76f1db17ed57ed50c4efd9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883557",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da3d832bb819cf4f487289e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883548",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_79b6683868d583b3df8c16e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883550",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb1b23cf908bf097d55af693",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883529",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_34f56693cb29a7fd659d164b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883528",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1b42ac7fb6f9cc561a2daef4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883527",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_42937dc92429d76e0940d2e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127868094",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4eea50ccb60a2b5833107e78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127868095",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_60d4fb22472d6ee3353d67d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127868096",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_704024ce01b812cd3936e506",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127868092",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73f7c6fe9753d2e29716c863",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127868090",
      "title": "High Speed Internet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c4320ca9fddb21963468b8cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628977",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5f9c95623551c6ae4c9e7595",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628974",
      "title": "Community Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-2b8a-7016-b083-08d60d1fb9fa.webp",
      "amenity_image_media": {
        "alt_text": "Modern living area with a white sectional sofa, coffee table, and kitchen island.",
        "public_id": "01a025e3-2b8a-7016-b083-08d60d1fb9fa",
        "storage_key": "property/6767906449167663/01a025e3-2b8a-7016-b083-08d60d1fb9fa.webp",
        "width": 2132,
        "height": 1421
      },
      "amenity_image_alt_text": "Open concept living room with high ceilings at Hangar at Bergstrom Apartments, Austin, TX,Open dining area with wooden banquette seating at Hangar at Bergstrom Apartments, Austin, TX,Clubhouse with pool table swing chair and dining area at Hangar at Bergstrom Apartments, Austin, 78744",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fad69d0e0c73ef2d2f7e591c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628971",
      "title": "Resort-Style Pool with Lounging Edge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-32de-76c2-b01a-824efdeeac3d.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor lounge area with ping pong table and pool view",
        "public_id": "01a025e3-32de-76c2-b01a-824efdeeac3d",
        "storage_key": "property/6767906449167663/01a025e3-32de-76c2-b01a-824efdeeac3d.webp",
        "width": 2132,
        "height": 1421
      },
      "amenity_image_alt_text": "Outdoor pergola dining area with pool views at Hangar at Bergstrom Apartments, Austin, 78744",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_30c5c9cdc5e4559692a90aec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628972",
      "title": "Direct Access to Nature Trails",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7486142de8dfeec444d7a0fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628973",
      "title": "24/7 Luxer Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-2a6e-775f-be7d-c1d2970d8f17.webp",
      "amenity_image_media": {
        "alt_text": "Modern mailroom with rows of mailboxes and a floral mural on the wall.",
        "public_id": "01a025e3-2a6e-775f-be7d-c1d2970d8f17",
        "storage_key": "property/6767906449167663/01a025e3-2a6e-775f-be7d-c1d2970d8f17.webp",
        "width": 2132,
        "height": 1421
      },
      "amenity_image_alt_text": "Mail room with wooden counters and black mailboxes at Hangar at Bergstrom Apartments, Austin, TX",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b3a122312a181c11db05477f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628975",
      "title": "Fully Equipped WiFi-Enabled Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-2b1e-73d6-9267-72881c826803.webp",
      "amenity_image_media": {
        "alt_text": "Modern fitness center with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "01a025e3-2b1e-73d6-9267-72881c826803",
        "storage_key": "property/6767906449167663/01a025e3-2b1e-73d6-9267-72881c826803.webp",
        "width": 2132,
        "height": 1421
      },
      "amenity_image_alt_text": "Spacious fitness center with floor to ceiling windows at Hangar at Bergstrom Apartments, Austin,Fitness center with treadmills and stair climber at Hangar at Bergstrom Apartments, Texas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_404385563790dffc6d6e2ac6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628976",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b8c770e3c79b0d00837d5999",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628978",
      "title": "Poolside Grills and Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_84718c198a9e875c278a2d78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628979",
      "title": "Resident Lounge with Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_db2005eda505b740c3457ab0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628980",
      "title": "On-Site Maintenance and Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bab803e998d954bae23eb985",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127913463",
      "title": "24/7 Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cb4ffb8ba2763bd4f665e0f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127913466",
      "title": "Coworking Business Spaces",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e41d1ae7026891964f4bcbb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127913470",
      "title": "EV Charging",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_43e0dd895b9d209abea95242",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127913472",
      "title": "Event Spaces",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2795bb3fbcea2cd9b18d5e00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127913474",
      "title": "Hiking Trails",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0aa474be1a2ca8d91fa6582b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127913477",
      "title": "Pool Tables",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_37f1a717029acd30424bb252",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127913480",
      "title": "Valet Trash",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e0f366385e321b3d0e79bf04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883583",
      "title": "Wheelchair Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e8df9b5bc1ed194de63dc0ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883582",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_59e78c599482f7f6c3682451",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883581",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f7cc3d1a1b408e425aa21a23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883579",
      "title": "View",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_527deaa5de4376c0316bcd55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883577",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_81fc76eaa76207a5eeeaa812",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883575",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_301b833d1ef74e39d53564ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883574",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9088c251cd8abb8955687554",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883573",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2bac575bd17bacbcf882450c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883571",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1b1b494b9c00f88f118d7fe6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883570",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b6e5eaf45206d76260b81665",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883568",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_15be6ad5034dbc109f1d6eaf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883569",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d979c51e9629e472b3f859b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883566",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_36393e2b9d5bfa1b893eff8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883565",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8fadb7df4f5f867a53ce9cb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883564",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5d1dafdd7939f10325acd578",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883562",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d49891161b25632a85a5a6b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883559",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_366e05bd31e073049b74f703",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883560",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4a6ce9ab817e8badb332a458",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127883584",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_384da193688f079bd21a5e6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628987",
      "title": "Luxury Vinyl Plank Flooring in Common Areas",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-2aae-77de-b1ba-ce55d3ec4f38.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and an island with bar stools.",
        "public_id": "01a025e3-2aae-77de-b1ba-ce55d3ec4f38",
        "storage_key": "property/6767906449167663/01a025e3-2aae-77de-b1ba-ce55d3ec4f38.webp",
        "width": 2132,
        "height": 1421
      },
      "amenity_image_alt_text": "Modern kitchen island with open floor plan at Hangar at Bergstrom Apartments, Texas, 78744",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6f074fb06008e333695c81d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628981",
      "title": "Quartz Countertops in Kitchens and Bathrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-4377-75ad-95ea-76d4ce51db93.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island with place settings.",
        "public_id": "01a025e3-4377-75ad-95ea-76d4ce51db93",
        "storage_key": "property/6767906449167663/01a025e3-4377-75ad-95ea-76d4ce51db93.webp",
        "width": 2132,
        "height": 1421
      },
      "amenity_image_alt_text": "Bright kitchen island with three place settings at Hangar at Bergstrom Apartments, Austin, TX 78744",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7d88a23bbe87fba8e201f5c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628982",
      "title": "Stainless Steel Appliances and Glass Cooktops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_128d922f00b3c1675060cbb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628983",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-44f0-77b9-ad26-33321e72677b.webp",
      "amenity_image_media": {
        "alt_text": "Living room with a gray sofa, coffee table, and a ceiling fan.",
        "public_id": "01a025e3-44f0-77b9-ad26-33321e72677b",
        "storage_key": "property/6767906449167663/01a025e3-44f0-77b9-ad26-33321e72677b.webp",
        "width": 2132,
        "height": 1421
      },
      "amenity_image_alt_text": "Living room with gray sofa and ceiling fan at Hangar at Bergstrom Apartments, Austin, Texas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e61ad7c21ab56db9590b30de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628984",
      "title": "Large Kitchen Islands",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f8a41c657ab8f6ca1f1ea26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628985",
      "title": "Modern Design",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_683949192304834d118a8529",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628986",
      "title": "Full-Size Washer and Dryer in Every Unit",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_060c1345dd371e6cf024cc24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628988",
      "title": "9' Ceilings Throughout",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40fec2c0db5b748e21f2bd45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628989",
      "title": "Carpet in Bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b12e1bc5d879b99dd2b3ad0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628990",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-4615-773f-9a23-26788e0f7ae7.webp",
      "amenity_image_media": {
        "alt_text": "Spacious walk-in closet with built-in shelving and hanging rods, featuring robes, bags, and baskets.",
        "public_id": "01a025e3-4615-773f-9a23-26788e0f7ae7",
        "storage_key": "property/6767906449167663/01a025e3-4615-773f-9a23-26788e0f7ae7.webp",
        "width": 2132,
        "height": 1421
      },
      "amenity_image_alt_text": "Walk-in closet with wooden shelving and hanging rods at Hangar at Bergstrom Apartments, Austin, TX 78744",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eefea60da62790d6aeb394f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628991",
      "title": "Private Patios and Balconies *",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53f182c5c7b7ff110a0ff497",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628992",
      "title": "Fenced Yards *",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f964eab9f9dc6586083708b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628993",
      "title": "Dual Vanities *",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_80bd34894519647c1dea07bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628994",
      "title": "Flexible Deposit Options with Jetty",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_33822cb2d508daba10d764d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "125628995",
      "title": "Flexible Payment Options with Flex",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0b2917559ae4da6141280956",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "yardi",
      "external_id": "127913461",
      "title": "Smart Locks W/Mobile Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_90060c253eb52175e09f8bd2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-1291-738d-9cca-a60a691cfee8.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs, umbrellas, and a covered patio with seating.",
        "public_id": "01a025e3-1291-738d-9cca-a60a691cfee8",
        "storage_key": "property/6767906449167663/01a025e3-1291-738d-9cca-a60a691cfee8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, featuring comfortable lounge chairs and a shaded patio area perfect for enjoying the sunshine or a cool breeze.",
      "link": "false",
      "alt_text": "Outdoor swimming pool area with lounge chairs, umbrellas, and a covered patio with seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-08.jpg"
    },
    {
      "id": "ec_b32c97166a9b9d75822bd70a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-5e3e-71de-94f5-7786e985a32d.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a pool table, hanging chair, and comfortable seating.",
        "public_id": "01a025e3-5e3e-71de-94f5-7786e985a32d",
        "storage_key": "property/6767906449167663/01a025e3-5e3e-71de-94f5-7786e985a32d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy leisure time in our stylish community lounge, featuring a billiard table, cozy seating, and a unique hanging chair. Perfect for socializing or relaxing.",
      "link": "false",
      "alt_text": "Modern lounge area with a pool table, hanging chair, and comfortable seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-05.jpg"
    },
    {
      "id": "ec_fba022fea41f7d9bfdb882ab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-5cbf-720b-bfbb-56f1c249962d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and an island with place settings.",
        "public_id": "01a025e3-5cbf-720b-bfbb-56f1c249962d",
        "storage_key": "property/6767906449167663/01a025e3-5cbf-720b-bfbb-56f1c249962d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment kitchen featuring white cabinetry, a full suite of stainless steel appliances, and a breakfast bar with elegant place settings.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and an island with place settings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-20.jpg"
    },
    {
      "id": "ec_8aaca568e5915b4b5e875264",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-5837-7009-9829-0241c9239fc6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and an island with bar stools.",
        "public_id": "01a025e3-5837-7009-9829-0241c9239fc6",
        "storage_key": "property/6767906449167663/01a025e3-5837-7009-9829-0241c9239fc6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and bright kitchen featuring ample cabinet space, a large island perfect for casual dining, and sleek stainless steel appliances. The open layout flows into the living area.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and an island with bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-18.jpg"
    },
    {
      "id": "ec_7ca231b46410e4e226757589",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-710c-7058-99ce-bda7b9d9557b.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with treadmills, ellipticals, weight machines, and dumbbells.",
        "public_id": "01a025e3-710c-7058-99ce-bda7b9d9557b",
        "storage_key": "property/6767906449167663/01a025e3-710c-7058-99ce-bda7b9d9557b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a full range of cardio and strength training equipment.",
      "link": "false",
      "alt_text": "Well-equipped fitness center with treadmills, ellipticals, weight machines, and dumbbells.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-15.jpg"
    },
    {
      "id": "ec_ebe3ac4e31c98f455f2ef8c8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-59ae-74ed-b176-b9acc59d212e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
        "public_id": "01a025e3-59ae-74ed-b176-b9acc59d212e",
        "storage_key": "property/6767906449167663/01a025e3-59ae-74ed-b176-b9acc59d212e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Chic kitchen featuring sleek stainless steel appliances, white subway tile backsplash, and ample cabinet space for all your culinary needs.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-22.jpg"
    },
    {
      "id": "ec_b6a126a688e451558d5fddfa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-8a83-75c9-9e6f-7511086c8ce0.webp",
      "image_media": {
        "alt_text": "Detail of a kitchen island with bar stools and a basket hanging in a recessed wall niche.",
        "public_id": "01a025e3-8a83-75c9-9e6f-7511086c8ce0",
        "storage_key": "property/6767906449167663/01a025e3-8a83-75c9-9e6f-7511086c8ce0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A modern kitchen with a sleek island, bar stools, and stylish pendant lights, complemented by a unique woven basket accent in a wall niche.",
      "link": "false",
      "alt_text": "Detail of a kitchen island with bar stools and a basket hanging in a recessed wall niche.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-17.jpg"
    },
    {
      "id": "ec_11d107f2400716015c48b3dd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-903a-749f-8f33-add46b317a7e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island.",
        "public_id": "01a025e3-903a-749f-8f33-add46b317a7e",
        "storage_key": "property/6767906449167663/01a025e3-903a-749f-8f33-add46b317a7e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A bright and spacious kitchen featuring white shaker cabinets, stainless steel appliances, quartz countertops, and a convenient island for dining and prep.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-21.jpg"
    },
    {
      "id": "ec_833b49b8e52ac5044a9a6949",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-9bfd-71a3-9dba-405745aa09ff.webp",
      "image_media": {
        "alt_text": "Kitchen island with place settings and view of living room.",
        "public_id": "01a025e3-9bfd-71a3-9dba-405745aa09ff",
        "storage_key": "property/6767906449167663/01a025e3-9bfd-71a3-9dba-405745aa09ff.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish kitchen island with place settings, overlooking a bright and airy living room with comfortable seating and large windows.",
      "link": "false",
      "alt_text": "Kitchen island with place settings and view of living room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-19.jpg"
    },
    {
      "id": "ec_a0b782f30637ea9d0cf98388",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-923b-72f7-8824-c6ffdf74fddc.webp",
      "image_media": {
        "alt_text": "Living room with a grey sectional sofa, wood coffee table, and ceiling fan.",
        "public_id": "01a025e3-923b-72f7-8824-c6ffdf74fddc",
        "storage_key": "property/6767906449167663/01a025e3-923b-72f7-8824-c6ffdf74fddc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable grey sofa, a modern wood coffee table, and elegant decor, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Living room with a grey sectional sofa, wood coffee table, and ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-23.jpg"
    },
    {
      "id": "ec_1bd6189b9194f1271cfef862",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-ac00-7484-bfa6-e3100a13e748.webp",
      "image_media": {
        "alt_text": "Interior bedroom with a bed, ceiling fan, and window.",
        "public_id": "01a025e3-ac00-7484-bfa6-e3100a13e748",
        "storage_key": "property/6767906449167663/01a025e3-ac00-7484-bfa6-e3100a13e748.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished bedroom featuring a comfortable bed, ceiling fan, and large window.",
      "link": "false",
      "alt_text": "Interior bedroom with a bed, ceiling fan, and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-24.jpg"
    },
    {
      "id": "ec_5b35398e4bbb54830dcbe658",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-bcc5-7131-9603-276ed503ef0a.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, modern ceiling fan, and large window with white curtains.",
        "public_id": "01a025e3-bcc5-7131-9603-276ed503ef0a",
        "storage_key": "property/6767906449167663/01a025e3-bcc5-7131-9603-276ed503ef0a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished bedroom featuring a comfortable king-size bed, a stylish ceiling fan, and ample natural light from a large window.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, modern ceiling fan, and large window with white curtains.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-26.jpg"
    },
    {
      "id": "ec_bfdeac8b097f1eed3e0ef001",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-becd-70a8-a2c1-bb628bb1a668.webp",
      "image_media": {
        "alt_text": "Walk-in closet with white walls, wood shelving, and hanging robes.",
        "public_id": "01a025e3-becd-70a8-a2c1-bb628bb1a668",
        "storage_key": "property/6767906449167663/01a025e3-becd-70a8-a2c1-bb628bb1a668.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving and hanging space, perfect for organizing your wardrobe.",
      "link": "false",
      "alt_text": "Walk-in closet with white walls, wood shelving, and hanging robes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-28.jpg"
    },
    {
      "id": "ec_b7724c1a24467693d42445fc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-ca12-71b4-a6da-6d38ce1d64b1.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a walk-in closet and a bathtub.",
        "public_id": "01a025e3-ca12-71b4-a6da-6d38ce1d64b1",
        "storage_key": "property/6767906449167663/01a025e3-ca12-71b4-a6da-6d38ce1d64b1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience luxury in this beautifully appointed bathroom, complete with a spacious walk-in closet and a relaxing bathtub, perfect for unwinding.",
      "link": "false",
      "alt_text": "Modern bathroom with a walk-in closet and a bathtub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-25.jpg"
    },
    {
      "id": "ec_e5ed2b2f8bfe6725618eb7a4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-cf87-75da-b50f-6e9799c8a0e1.webp",
      "image_media": {
        "alt_text": "Modern mailroom with floral mural and wood accents.",
        "public_id": "01a025e3-cf87-75da-b50f-6e9799c8a0e1",
        "storage_key": "property/6767906449167663/01a025e3-cf87-75da-b50f-6e9799c8a0e1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our community's stylish mailroom, featuring a vibrant floral mural, ample mailboxes, and warm wood finishes. A beautifully designed space for all residents.",
      "link": "false",
      "alt_text": "Modern mailroom with floral mural and wood accents.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-14.jpg"
    },
    {
      "id": "ec_3bb1b24aeb13793e642d3420",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-e69a-730f-b46e-db2286b59224.webp",
      "image_media": {
        "alt_text": "Spacious community lounge with seating areas, a kitchen island, and large windows overlooking a pool.",
        "public_id": "01a025e3-e69a-730f-b46e-db2286b59224",
        "storage_key": "property/6767906449167663/01a025e3-e69a-730f-b46e-db2286b59224.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our modern and inviting community lounge, featuring comfortable seating, a fully equipped kitchen island, and beautiful views of the outdoor pool area. Perfect for socializing or relaxing.",
      "link": "false",
      "alt_text": "Spacious community lounge with seating areas, a kitchen island, and large windows overlooking a pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-09.jpg"
    },
    {
      "id": "ec_df25d75d70e21f93f0da4316",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-ef27-73c4-b7d1-090555a70578.webp",
      "image_media": {
        "alt_text": "Stylish living room and kitchen area with a large window overlooking greenery.",
        "public_id": "01a025e3-ef27-73c4-b7d1-090555a70578",
        "storage_key": "property/6767906449167663/01a025e3-ef27-73c4-b7d1-090555a70578.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern and inviting living room and kitchen space, perfect for relaxing or entertaining. Features comfortable seating, a sleek island, and abundant natural light.",
      "link": "false",
      "alt_text": "Stylish living room and kitchen area with a large window overlooking greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-01.jpg"
    },
    {
      "id": "ec_d59e348fa9c2008a81e98c3d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-ea23-75d4-8c7d-75d2ffad1191.webp",
      "image_media": {
        "alt_text": "Modern kitchen with grey cabinets, gold hardware, and a brass faucet.",
        "public_id": "01a025e3-ea23-75d4-8c7d-75d2ffad1191",
        "storage_key": "property/6767906449167663/01a025e3-ea23-75d4-8c7d-75d2ffad1191.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Elegant kitchen featuring sleek grey cabinetry, complemented by lustrous gold hardware and a stylish brass faucet.",
      "link": "false",
      "alt_text": "Modern kitchen with grey cabinets, gold hardware, and a brass faucet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-13.jpg"
    },
    {
      "id": "ec_0825436f9b1eda3b8aba2c09",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e3-f957-75de-92fc-68f0b50f1068.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, and stair climber",
        "public_id": "01a025e3-f957-75de-92fc-68f0b50f1068",
        "storage_key": "property/6767906449167663/01a025e3-f957-75de-92fc-68f0b50f1068.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring treadmills, an elliptical machine, and a stair climber, with large windows overlooking the outdoor pool area.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, elliptical, and stair climber",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-16.jpg"
    },
    {
      "id": "ec_496f59fdd23b44ccdcf68899",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e4-012d-76dc-8c7a-91fd6155a126.webp",
      "image_media": {
        "alt_text": "View of pool area and lounge seating through large windows, with bar stools in foreground.",
        "public_id": "01a025e4-012d-76dc-8c7a-91fd6155a126",
        "storage_key": "property/6767906449167663/01a025e4-012d-76dc-8c7a-91fd6155a126.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the view of our sparkling pool and lush landscaping from the comfort of our indoor lounge area. Perfect for relaxing or socializing.",
      "link": "false",
      "alt_text": "View of pool area and lounge seating through large windows, with bar stools in foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-10.jpg"
    },
    {
      "id": "ec_e2d3af61b74cb8801c2df5dc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e4-1a3a-724e-94d6-a8a353019659.webp",
      "image_media": {
        "alt_text": "Community lounge area with large table and chairs overlooking the pool",
        "public_id": "01a025e4-1a3a-724e-94d6-a8a353019659",
        "storage_key": "property/6767906449167663/01a025e4-1a3a-724e-94d6-a8a353019659.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our spacious community lounge, perfect for work or relaxation, with views of the outdoor pool area.",
      "link": "false",
      "alt_text": "Community lounge area with large table and chairs overlooking the pool",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-06.jpg"
    },
    {
      "id": "ec_210483b03b197640279b41d0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e4-1b63-707d-98b9-65e6cb2cc5bf.webp",
      "image_media": {
        "alt_text": "Booths with upholstered seating and built-in desks with wall-mounted lamps.",
        "public_id": "01a025e4-1b63-707d-98b9-65e6cb2cc5bf",
        "storage_key": "property/6767906449167663/01a025e4-1b63-707d-98b9-65e6cb2cc5bf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a quiet moment in our private work booths, featuring comfortable seating and convenient built-in desks perfect for productivity.",
      "link": "false",
      "alt_text": "Booths with upholstered seating and built-in desks with wall-mounted lamps.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-04.jpg"
    },
    {
      "id": "ec_9244b331624f50c067a8ee5d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e4-2701-76fe-a34f-2a59353351d7.webp",
      "image_media": {
        "alt_text": "Stylish co-working space with multiple desks and seating areas, adjacent to a modern kitchen and living room.",
        "public_id": "01a025e4-2701-76fe-a34f-2a59353351d7",
        "storage_key": "property/6767906449167663/01a025e4-2701-76fe-a34f-2a59353351d7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover a sophisticated co-working space designed for productivity and comfort, seamlessly integrated with stylish living and kitchen areas.",
      "link": "false",
      "alt_text": "Stylish co-working space with multiple desks and seating areas, adjacent to a modern kitchen and living room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-03.jpg"
    },
    {
      "id": "ec_7a4b4e797be62f333cfc8d75",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e4-33f2-70fd-b521-0d711d5bc999.webp",
      "image_media": {
        "alt_text": "Bright and airy lounge area with large windows, comfortable seating, and modern design.",
        "public_id": "01a025e4-33f2-70fd-b521-0d711d5bc999",
        "storage_key": "property/6767906449167663/01a025e4-33f2-70fd-b521-0d711d5bc999.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our beautifully designed lounge, perfect for relaxing or working. Features ample natural light and stylish furnishings.",
      "link": "false",
      "alt_text": "Bright and airy lounge area with large windows, comfortable seating, and modern design.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-11.jpg"
    },
    {
      "id": "ec_b550cf2c10d5dfff9e9698f2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/01a025e4-3f44-71b8-ad8c-12eb086b35c8.webp",
      "image_media": {
        "alt_text": "Modern co-working spaces with individual desks and seating areas.",
        "public_id": "01a025e4-3f44-71b8-ad8c-12eb086b35c8",
        "storage_key": "property/6767906449167663/01a025e4-3f44-71b8-ad8c-12eb086b35c8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover our thoughtfully designed co-working spaces, perfect for remote work or focused study. Enjoy comfortable seating and ample desk space.",
      "link": "false",
      "alt_text": "Modern co-working spaces with individual desks and seating areas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/bergstrom-12.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_f666bef3-2415-4ca8-bc97-21f8bf2fe237",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "CJ's Tacos - Burleson",
      "poi_type": "Restaurants",
      "poi_address": "5804 Burleson Rd, Austin, TX 78744, USA",
      "poi_short_description": "Relaxed spot dishing up a wide variety of tacos from a takeout restaurant or food truck setting, plus tortillas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-952b-7530-a3ef-84ee594c99d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-952b-7530-a3ef-84ee594c99d9",
        "storage_key": "property/6767906449167663/019ffd1d-952b-7530-a3ef-84ee594c99d9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://instagram.com/cjs_tacos?utm_medium=copy_link",
      "poi_directions_map_url": "https://maps.google.com/?cid=3483342534603275443&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cjs-tacos---burleson",
      "poi_latitude": "30.2081502",
      "poi_longitude": "-97.7211545",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 512-995-4199",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3824-769a-8093-0743cf9a42b8",
        "storage_key": "property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVZj7x-zRIYRs3wJZpRRVzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taco_restaurant"
    },
    {
      "id": "custom_70310b6b-e6b8-4531-b090-65bf62d311a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "El Pollo Sierreño #5",
      "poi_type": "Restaurants",
      "poi_address": "6300 Burleson Rd, Austin, TX 78744, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-8e25-708b-97b6-f60283c1716c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-8e25-708b-97b6-f60283c1716c",
        "storage_key": "property/6767906449167663/019ffd1d-8e25-708b-97b6-f60283c1716c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lahawaiianapollos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13439318802700325995&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-pollo-sierreo-5",
      "poi_latitude": "30.2056846",
      "poi_longitude": "-97.7158176",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 737-312-7966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3824-769a-8093-0743cf9a42b8",
        "storage_key": "property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo45guzi1RIYRa1QuGj8Ngro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_69b45f3a-f13e-4c3b-9345-529f693c4c61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "The Ella Bistro",
      "poi_type": "Restaurants",
      "poi_address": "6002 Burleson Rd, Austin, TX 78744, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-9657-70ed-a63e-d06add6745d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-9657-70ed-a63e-d06add6745d4",
        "storage_key": "property/6767906449167663/019ffd1d-9657-70ed-a63e-d06add6745d4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7761433733166769287&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-ella-bistro",
      "poi_latitude": "30.2065989",
      "poi_longitude": "-97.7182539",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 512-215-0973",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3824-769a-8093-0743cf9a42b8",
        "storage_key": "property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJF8a6HwCzRIYRh6Qjxdsmtms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "custom_f3a27a22-6ab8-4810-890f-d2d05146a58a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Tu casa Azteca",
      "poi_type": "Restaurants",
      "poi_address": "6002 Burleson Rd, Austin, TX 78744, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-91a3-70d2-8074-e0e5eef2c6ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-91a3-70d2-8074-e0e5eef2c6ae",
        "storage_key": "property/6767906449167663/019ffd1d-91a3-70d2-8074-e0e5eef2c6ae.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1965517894908557066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tu-casa-azteca",
      "poi_latitude": "30.2065989",
      "poi_longitude": "-97.7182539",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 512-326-1213",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3824-769a-8093-0743cf9a42b8",
        "storage_key": "property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJeRpMuKqzRIYRCreylRzsRhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_c88c4a89-6573-4021-94ba-9b67afc005eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Radio/East",
      "poi_type": "Restaurants",
      "poi_address": "3504 Montopolis Dr, Austin, TX 78744, USA",
      "poi_short_description": "Relaxed coffeehouse offering comfort food, beer, cocktails, live music, and a patio.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-9b53-70d9-95c0-32ddd92e8896.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-9b53-70d9-95c0-32ddd92e8896",
        "storage_key": "property/6767906449167663/019ffd1d-9b53-70d9-95c0-32ddd92e8896.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.radiocoffeeandbeer.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3380012237344186433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "radioeast",
      "poi_latitude": "30.2079535",
      "poi_longitude": "-97.7155226",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 512-461-2834",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-f6f8-7041-862d-1a33e5edba80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-f6f8-7041-862d-1a33e5edba80",
        "storage_key": "property/6767906449167663/019ffd1d-f6f8-7041-862d-1a33e5edba80.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJn_P-01SzRIYRQaBfxzg36C4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_648f6ce2-57b0-4ded-a3e0-5033efd9f60f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Veracruz All Natural",
      "poi_type": "Restaurants",
      "poi_address": "3504 Montopolis Dr, Austin, TX 78744, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-97cf-77b9-8a12-27baddd3c71a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-97cf-77b9-8a12-27baddd3c71a",
        "storage_key": "property/6767906449167663/019ffd1d-97cf-77b9-8a12-27baddd3c71a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://veracruzallnatural.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12305054214307096110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "veracruz-all-natural",
      "poi_latitude": "30.2081194",
      "poi_longitude": "-97.7152143",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 512-690-7638",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3824-769a-8093-0743cf9a42b8",
        "storage_key": "property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0aRF11yzRIYRLqay6ZxVxKo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_11cab99a-5909-44a3-ba5d-b41b3dd33b93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Whole Lotta Soul",
      "poi_type": "Restaurants",
      "poi_address": "Pickup @ Expo Window, 3400 Comsouth Dr, Austin, TX 78744, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-9336-74a8-ae02-947230ce1b18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-9336-74a8-ae02-947230ce1b18",
        "storage_key": "property/6767906449167663/019ffd1d-9336-74a8-ae02-947230ce1b18.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.orderwholelottasoul.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7660092573316515145&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-lotta-soul",
      "poi_latitude": "30.21258",
      "poi_longitude": "-97.7200951",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 737-334-6797",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3824-769a-8093-0743cf9a42b8",
        "storage_key": "property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJeXCGHq-1RIYRSYUjS5wdTmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_f978ac97-8e9d-457c-8159-1c0670536bad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Hawaiian Bros Island Grill",
      "poi_type": "Restaurants",
      "poi_address": "3400 Comsouth Dr, Austin, TX 78744, USA",
      "poi_short_description": "Low-key eatery popular for lunch and catering, offering Hawaiian dishes and macaroni salad.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-9596-7753-a353-85448ad187a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-9596-7753-a353-85448ad187a8",
        "storage_key": "property/6767906449167663/019ffd1d-9596-7753-a353-85448ad187a8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.hawaiianbros.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1256281029900354349&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hawaiian-bros-island-grill",
      "poi_latitude": "30.2125828",
      "poi_longitude": "-97.7200726",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 737-802-8608",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3824-769a-8093-0743cf9a42b8",
        "storage_key": "property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBbXQcry1RIYRLcNFzfA0bxE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hawaiian_restaurant"
    },
    {
      "id": "custom_199b8297-d734-44eb-aff5-cb532bfa8721",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Vic's Bar-B-Que",
      "poi_type": "Restaurants",
      "poi_address": "3502 Burleson Rd, Austin, TX 78741, USA",
      "poi_short_description": "Wood-paneled, counter-service barbecue pit dispensing breakfast tacos & meats in low-key environs.",
      "poi_long_description": "Wood-paneled, counter-service barbecue pit dispensing breakfast tacos & meats in low-key environs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-92ce-70cb-8d7f-6aedecb85a6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-92ce-70cb-8d7f-6aedecb85a6d",
        "storage_key": "property/6767906449167663/019ffd1d-92ce-70cb-8d7f-6aedecb85a6d.webp",
        "width": 1066,
        "height": 601
      },
      "poi_business_url": "http://vicsbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=615954362787018996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vics-bar-b-que",
      "poi_latitude": "30.2164517",
      "poi_longitude": "-97.7348063",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 512-445-4250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3824-769a-8093-0743cf9a42b8",
        "storage_key": "property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq15xC3u0RIYR9LjFvzpPjAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_ff0e6df8-b130-4d65-8b16-02534a1ee246",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "The Peached Tortilla",
      "poi_type": "Restaurants",
      "poi_address": "3600 Presidential Blvd, Austin, TX 78719, USA",
      "poi_short_description": "Fast-food counter serving Southern comfort eats with an Asian twist such as banh mi tacos & ramen.",
      "poi_long_description": "Fast-food counter serving Southern comfort eats with an Asian twist such as banh mi tacos & ramen.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-92c2-7448-a5d5-6a606f093896.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-92c2-7448-a5d5-6a606f093896",
        "storage_key": "property/6767906449167663/019ffd1d-92c2-7448-a5d5-6a606f093896.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://thepeachedtortilla.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11936384935540787987&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-peached-tortilla",
      "poi_latitude": "30.2021122",
      "poi_longitude": "-97.6659706",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3824-769a-8093-0743cf9a42b8",
        "storage_key": "property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuz2JE1mxRIYRE4s7cduOpqU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_2902258d-dcb4-442b-9028-c893815caf6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Annies",
      "poi_type": "Restaurants",
      "poi_address": "3600 Presidential Blvd, Austin, TX 78719, USA",
      "poi_short_description": "Relaxed cafe for breakfast tacos, sandwiches and salads along with coffees and teas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-a2d7-7699-a822-6e74e69dc9b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-a2d7-7699-a822-6e74e69dc9b1",
        "storage_key": "property/6767906449167663/019ffd1d-a2d7-7699-a822-6e74e69dc9b1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13854563396589044153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "annies",
      "poi_latitude": "30.202292",
      "poi_longitude": "-97.6700153",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 512-530-2242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-f6f8-7041-862d-1a33e5edba80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-f6f8-7041-862d-1a33e5edba80",
        "storage_key": "property/6767906449167663/019ffd1d-f6f8-7041-862d-1a33e5edba80.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJE3m72zCxRIYRucHRKwFMRcA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_1c2dd582-5a4c-42e2-b277-85a749cf7ae3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Tacodeli",
      "poi_type": "Restaurants",
      "poi_address": "3600 Presidential Blvd, Austin, TX 78719, USA",
      "poi_short_description": "Informal outpost serving Mexican breakfast, lunch & dinner tacos with eggs, meats & veggies.",
      "poi_long_description": "Informal outpost serving Mexican breakfast, lunch & dinner tacos with eggs, meats & veggies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-a45d-76c8-a39a-ac9c88195437.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-a45d-76c8-a39a-ac9c88195437",
        "storage_key": "property/6767906449167663/019ffd1d-a45d-76c8-a39a-ac9c88195437.webp",
        "width": 1280,
        "height": 986
      },
      "poi_business_url": "https://locations.tacodeli.com/locations/austin/3600-presidential-blvd",
      "poi_directions_map_url": "https://maps.google.com/?cid=7218694841492668104&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tacodeli",
      "poi_latitude": "30.2021825",
      "poi_longitude": "-97.6687189",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3824-769a-8093-0743cf9a42b8",
        "storage_key": "property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0SERKkCxRIYRyH4dSbb0LWQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_085ee8af-2829-425e-af14-43e7502b21d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Earl Campbell's Tacos",
      "poi_type": "Restaurants",
      "poi_address": "3600 Presidential Blvd, Austin, TX 78719, USA",
      "poi_short_description": "Casual airport fast-food truck serving tacos and bowls for breakfast and lunch.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-a844-7483-b835-93bcf3dea8eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-a844-7483-b835-93bcf3dea8eb",
        "storage_key": "property/6767906449167663/019ffd1d-a844-7483-b835-93bcf3dea8eb.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "http://earl-campbells-tacos.lany.io/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2557949562875906309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "earl-campbells-tacos",
      "poi_latitude": "30.2020103",
      "poi_longitude": "-97.6669976",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3824-769a-8093-0743cf9a42b8",
        "storage_key": "property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9xHjk6OxRIYRBYmVKJOpfyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_d3cb68d0-c01d-428b-b715-d77ec994a66d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Hut’s Hamburgers",
      "poi_type": "Restaurants",
      "poi_address": "3600 Presidential Blvd, Austin, TX 78719, USA",
      "poi_short_description": "Casual burger spot inside the airport offering fried sides and live music.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-a8ac-7108-9962-8a8a858f8003.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-a8ac-7108-9962-8a8a858f8003",
        "storage_key": "property/6767906449167663/019ffd1d-a8ac-7108-9962-8a8a858f8003.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8451280933208674473&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "huts-hamburgers",
      "poi_latitude": "30.20241069999999",
      "poi_longitude": "-97.664953",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3824-769a-8093-0743cf9a42b8",
        "storage_key": "property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLzw2WwKxRIYRqVDvYDv7SHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_f9468b59-0b61-4bab-91c5-9a62ad86609e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Super Moreliana",
      "poi_type": "Shopping & Retail",
      "poi_address": "6112 S Hwy 183 S, Austin, TX 78744, USA",
      "poi_short_description": "Grocery store offering fresh produce, Mexican food, and a taqueria, plus meat grilling.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-a71a-70b0-954a-0340242386ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-a71a-70b0-954a-0340242386ea",
        "storage_key": "property/6767906449167663/019ffd1d-a71a-70b0-954a-0340242386ea.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15262056028108782854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "super-moreliana",
      "poi_latitude": "30.1676668",
      "poi_longitude": "-97.692529",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 512-243-1114",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3805-7508-b498-6cae143dd655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3805-7508-b498-6cae143dd655",
        "storage_key": "property/6767906449167663/019ffd1a-3805-7508-b498-6cae143dd655.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA17pOnmxRIYRBn2IgRi3zdM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_28ce3d58-1319-4ca8-9ec3-7aa051bd3e0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "CHEVRON - ALL STAR GROCERY # 2",
      "poi_type": "Shopping & Retail",
      "poi_address": "5303 Nuckols Crossing Rd, Austin, TX 78744, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-a4b1-736c-887b-b83f64e96f1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-a4b1-736c-887b-b83f64e96f1d",
        "storage_key": "property/6767906449167663/019ffd1d-a4b1-736c-887b-b83f64e96f1d.webp",
        "width": 1026,
        "height": 900
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9310422364669706055&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chevron---all-star-grocery--2",
      "poi_latitude": "30.192618",
      "poi_longitude": "-97.7386672",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 512-445-5059",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3805-7508-b498-6cae143dd655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3805-7508-b498-6cae143dd655",
        "storage_key": "property/6767906449167663/019ffd1a-3805-7508-b498-6cae143dd655.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZVT-VJyzRIYRR3_92s9DNYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_7a750325-98a2-4e7d-9371-08b8aa17b8fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Mobil - JD's Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "7310 E Riverside Dr, Austin, TX 78741, USA",
      "poi_short_description": "Grocery store offering burritos, tacos and fajitas, plus bakery items.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-ad60-727e-86db-525ea275bd9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-ad60-727e-86db-525ea275bd9a",
        "storage_key": "property/6767906449167663/019ffd1d-ad60-727e-86db-525ea275bd9a.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.jdmarkets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11610178280714038665&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mobil---jds-market",
      "poi_latitude": "30.2209004",
      "poi_longitude": "-97.6938835",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 512-386-7742",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3805-7508-b498-6cae143dd655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3805-7508-b498-6cae143dd655",
        "storage_key": "property/6767906449167663/019ffd1a-3805-7508-b498-6cae143dd655.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8arJoqi2RIYRiW3qCKKjH6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_9aa9454b-7b9b-43ee-8ec3-812843205820",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "7101 E William Cannon Dr, Austin, TX 78744, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-abcf-7451-aacc-9f2b35634985.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-abcf-7451-aacc-9f2b35634985",
        "storage_key": "property/6767906449167663/019ffd1d-abcf-7451-aacc-9f2b35634985.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/austin-tx-pharmacies/7101-e-william-cannon-drive-austin-tx-78744/storeid=11306?WT.mc_id=LS_GOOGLE_RX_11306",
      "poi_directions_map_url": "https://maps.google.com/?cid=14781396053247572378&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "30.1620614",
      "poi_longitude": "-97.7257595",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 737-220-9738",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-f6fa-72ee-ac3b-d0c87ba25112.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-f6fa-72ee-ac3b-d0c87ba25112",
        "storage_key": "property/6767906449167663/019ffd1d-f6fa-72ee-ac3b-d0c87ba25112.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh4manJKzRIYRmrkuLmURIs0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_dd919b58-82f1-493a-ae6a-a71e6b72556e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Burpy Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6311 Burleson Rd, Austin, TX 78744, USA",
      "poi_short_description": "Convenience store providing prepared foods and gas, plus a public restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-ad58-72df-ad59-c2757ec18c97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-ad58-72df-ad59-c2757ec18c97",
        "storage_key": "property/6767906449167663/019ffd1d-ad58-72df-ad59-c2757ec18c97.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.exxon.com/en/find-station/austin-tx-burpymarket-200322327",
      "poi_directions_map_url": "https://maps.google.com/?cid=12829691240360697110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burpy-market",
      "poi_latitude": "30.2047916",
      "poi_longitude": "-97.7163818",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 512-386-5329",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-f6f9-7468-901f-cba48e447ff3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-f6f9-7468-901f-cba48e447ff3",
        "storage_key": "property/6767906449167663/019ffd1d-f6f9-7468-901f-cba48e447ff3.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ7UVeRPSzRIYRFt2jXzU4DLI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_1931a4e6-b628-4e63-ab6d-c4085e72b769",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Tex-Con Oil",
      "poi_type": "Shopping & Retail",
      "poi_address": "4906 Burleson Rd, Austin, TX 78744, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-b603-746f-bd66-dc957673bbfd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-b603-746f-bd66-dc957673bbfd",
        "storage_key": "property/6767906449167663/019ffd1d-b603-746f-bd66-dc957673bbfd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.texconoil.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15613420763096103838&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tex-con-oil",
      "poi_latitude": "30.2126874",
      "poi_longitude": "-97.7300208",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 512-444-1941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-383e-70b4-8c93-46c86d467817",
        "storage_key": "property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdbhMRHe0RIYRnjsN6XUDrtg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_03920fa9-6b81-4d77-bae5-a11878ccbc02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Goodwill Central Texas - Outlet South",
      "poi_type": "Shopping & Retail",
      "poi_address": "6505 Burleson Rd, Austin, TX 78744, USA",
      "poi_short_description": "Long-standing nonprofit chain with a range of pre-owned clothing, furniture, housewares & more.",
      "poi_long_description": "Long-standing nonprofit chain with a range of pre-owned clothing, furniture, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-b97a-7009-95ab-41f0caa1aff1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-b97a-7009-95ab-41f0caa1aff1",
        "storage_key": "property/6767906449167663/019ffd1d-b97a-7009-95ab-41f0caa1aff1.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.goodwillcentraltexas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1074610191247017147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "goodwill-central-texas---outlet-south",
      "poi_latitude": "30.203366",
      "poi_longitude": "-97.7143392",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 512-681-3301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3826-73fd-a0b1-382639fff5d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3826-73fd-a0b1-382639fff5d8",
        "storage_key": "property/6767906449167663/019ffd1a-3826-73fd-a0b1-382639fff5d8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZVg-__OzRIYRuwRLgUbI6Q4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thrift_store"
    },
    {
      "id": "custom_6440f851-ef32-47ab-9a15-46522f4a0eb1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "9300 I-35 Ste B, Austin, TX 78748, USA",
      "poi_short_description": "Department store carrying a wide range of items, including apparel, home goods, and electronics, plus repairs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-b5fb-77de-a9b8-17fdfd4ddbf0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-b5fb-77de-a9b8-17fdfd4ddbf0",
        "storage_key": "property/6767906449167663/019ffd1d-b5fb-77de-a9b8-17fdfd4ddbf0.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/5317-austin-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17809410453757727807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "30.1649618",
      "poi_longitude": "-97.7899762",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 512-292-6973",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3826-73fd-a0b1-382639fff5d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3826-73fd-a0b1-382639fff5d8",
        "storage_key": "property/6767906449167663/019ffd1a-3826-73fd-a0b1-382639fff5d8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJyQd6n9NMW4YRP5RbC3O8J_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_1c44bc6e-c5f6-449f-975c-b6b365a14240",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "9500 S I-35 Frontage Rd Ste G, Austin, TX 78748, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-b1a1-732d-8ea5-2e2863121bd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-b1a1-732d-8ea5-2e2863121bd1",
        "storage_key": "property/6767906449167663/019ffd1d-b1a1-732d-8ea5-2e2863121bd1.webp",
        "width": 1280,
        "height": 925
      },
      "poi_business_url": "https://www.target.com/sl/austin-southpark/2288",
      "poi_directions_map_url": "https://maps.google.com/?cid=5224663164184442623&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "30.1633333",
      "poi_longitude": "-97.7934564",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 512-687-0634",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3826-73fd-a0b1-382639fff5d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3826-73fd-a0b1-382639fff5d8",
        "storage_key": "property/6767906449167663/019ffd1a-3826-73fd-a0b1-382639fff5d8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhVwwO9dMW4YR_zZIZHe7gUg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_f0315a61-646d-447d-a33c-b63c81c2b914",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "KinderCare at Bergstrom Tech",
      "poi_type": "Education",
      "poi_address": "6800 Burleson Rd Bldg 312 Suite 170, Austin, TX 78744, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-b9d3-75d3-91a7-b135a47ebe34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-b9d3-75d3-91a7-b135a47ebe34",
        "storage_key": "property/6767906449167663/019ffd1d-b9d3-75d3-91a7-b135a47ebe34.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/austin/tx/081082?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_MjgxNjcwNDAtNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=955692088546874668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kindercare-at-bergstrom-tech",
      "poi_latitude": "30.20210729999999",
      "poi_longitude": "-97.7027662",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 512-386-5541",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3829-75c9-83fe-b255894aac29",
        "storage_key": "property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8xa7bcqzRIYRLNV8HORMQw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_24304564-318d-4bd2-94a6-bcf5233c3ee3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Hillcrest Elementary School",
      "poi_type": "Education",
      "poi_address": "6910 E William Cannon Dr, Austin, TX 78744, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://hes.dvisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18022782367093641604&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hillcrest-elementary-school",
      "poi_latitude": "30.1654102",
      "poi_longitude": "-97.7290982",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 512-386-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3829-75c9-83fe-b255894aac29",
        "storage_key": "property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc0ZKibKzRIYRhFHK9hLJHfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_26f7a901-5728-4d40-8e12-e10048689ccc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Newton Collins Elementary",
      "poi_type": "Education",
      "poi_address": "7609 Apogee Blvd, Austin, TX 78744, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-c00e-734f-9c53-544ff3b93094.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-c00e-734f-9c53-544ff3b93094",
        "storage_key": "property/6767906449167663/019ffd1d-c00e-734f-9c53-544ff3b93094.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://nces.dvisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12202770029252150734&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newton-collins-elementary",
      "poi_latitude": "30.1528956",
      "poi_longitude": "-97.7137327",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 512-386-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3829-75c9-83fe-b255894aac29",
        "storage_key": "property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi129uDCyRIYRzoVbRbDyWKk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f5630155-ec4f-4bf7-9a16-76cc39527a68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Smith Elementary School",
      "poi_type": "Education",
      "poi_address": "4209 Smith School Rd, Austin, TX 78744, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://ses.dvisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1575574206871761654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smith-elementary-school",
      "poi_latitude": "30.1964453",
      "poi_longitude": "-97.7132755",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 512-386-3850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3829-75c9-83fe-b255894aac29",
        "storage_key": "property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP5jARPCzRIYR9vLbtWSQ3RU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_245cec2a-5802-40e6-b0f8-f9d7e8cdeb16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Ojeda Middle School",
      "poi_type": "Education",
      "poi_address": "4900 McKinney Falls Pkwy, Austin, TX 78744, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-b721-747f-b536-0fbda6ad7d6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-b721-747f-b536-0fbda6ad7d6d",
        "storage_key": "property/6767906449167663/019ffd1d-b721-747f-b536-0fbda6ad7d6d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://oms.dvisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4345050457203526559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ojeda-middle-school",
      "poi_latitude": "30.1904829",
      "poi_longitude": "-97.7126537",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 512-386-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3829-75c9-83fe-b255894aac29",
        "storage_key": "property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPZUEl-izRIYRn8vDqF64TDw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_312a7b34-e7cc-4d63-9b78-ff11f2443dd6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Del Valle High School",
      "poi_type": "Education",
      "poi_address": "5201 Ross Rd, Del Valle, TX 78617, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-b9da-723b-a299-f256c8244fc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-b9da-723b-a299-f256c8244fc0",
        "storage_key": "property/6767906449167663/019ffd1d-b9da-723b-a299-f256c8244fc0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://dvhs.dvisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3220859849038349476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "del-valle-high-school",
      "poi_latitude": "30.1801157",
      "poi_longitude": "-97.611976",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 512-386-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3829-75c9-83fe-b255894aac29",
        "storage_key": "property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPbsEV4iwRIYRpMQ_xffKsiw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_db8c5215-1a54-4a36-80dc-b045816a2491",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Del Valle Child Development Center",
      "poi_type": "Education",
      "poi_address": "5301 Ross Rd Bldg. C, Del Valle, TX 78617, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-bcff-721e-809a-2b552e7507f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-bcff-721e-809a-2b552e7507f5",
        "storage_key": "property/6767906449167663/019ffd1d-bcff-721e-809a-2b552e7507f5.webp",
        "width": 700,
        "height": 467
      },
      "poi_business_url": "http://cdc.dvisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15293085361945341071&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "del-valle-child-development-center",
      "poi_latitude": "30.1745692",
      "poi_longitude": "-97.610172",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 512-386-3727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3829-75c9-83fe-b255894aac29",
        "storage_key": "property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5eJ39YWwRIYRj2x6Rhz0O9Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_db0327c5-ccce-4795-8b73-f62d5cc6f148",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Dove Springs Cdc",
      "poi_type": "Education",
      "poi_address": "5106 Village Square Dr, Austin, TX 78744, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://childinc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16513886036298519486&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dove-springs-cdc",
      "poi_latitude": "30.1886755",
      "poi_longitude": "-97.7430554",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 512-768-5390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3829-75c9-83fe-b255894aac29",
        "storage_key": "property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQzJsunWzRIYRvlPbDtsbLeU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_0c6f8126-5947-4ba8-8bb6-da3729fd5820",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Popham Elementary School",
      "poi_type": "Education",
      "poi_address": "7014 Elroy Rd, Del Valle, TX 78617, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-be80-77ee-af28-945f180b22d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-be80-77ee-af28-945f180b22d5",
        "storage_key": "property/6767906449167663/019ffd1d-be80-77ee-af28-945f180b22d5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://pes.dvisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1346507096657893301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "popham-elementary-school",
      "poi_latitude": "30.1578444",
      "poi_longitude": "-97.6439567",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 512-386-3750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3829-75c9-83fe-b255894aac29",
        "storage_key": "property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3Y3OmCq3RIYRtRfW_xHBrxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_1b125834-51ff-49f8-a7af-76d6d1595f3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Austin Community College: Riverside Campus",
      "poi_type": "Education",
      "poi_address": "1020 Grove Blvd, Austin, TX 78741, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd19-e773-746c-a646-bea28382a350.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd19-e773-746c-a646-bea28382a350",
        "storage_key": "property/6767906449167663/019ffd19-e773-746c-a646-bea28382a350.webp",
        "width": 1067,
        "height": 800
      },
      "poi_business_url": "http://www.austincc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4779545164519051975&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "austin-community-college-riverside-campus",
      "poi_latitude": "30.2369688",
      "poi_longitude": "-97.7047836",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 512-223-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3829-75c9-83fe-b255894aac29",
        "storage_key": "property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiUNi6SO0RIYRxxIYBwFbVEI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ed2ff70d-2501-43ed-bfcf-bc4c6678899d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Cinemark Southpark Meadows",
      "poi_type": "Entertainment",
      "poi_address": "9900 S IH-35 Service Road SB Unit N, Austin, TX 78748, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-c1a0-72c9-9f1c-c2b47e6dd7fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-c1a0-72c9-9f1c-c2b47e6dd7fe",
        "storage_key": "property/6767906449167663/019ffd1d-c1a0-72c9-9f1c-c2b47e6dd7fe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-austin/cinemark-southpark-meadows?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&y_source=1_MTc0OTMyMDEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6307665614318012410&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-southpark-meadows",
      "poi_latitude": "30.154068",
      "poi_longitude": "-97.7941883",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 512-291-0171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-f6ff-74aa-8cb2-df136b4bb936.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-f6ff-74aa-8cb2-df136b4bb936",
        "storage_key": "property/6767906449167663/019ffd1d-f6ff-74aa-8cb2-df136b4bb936.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJyQd6n9NMW4YR-gdf73RUiVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_ad9fbdc4-e2dc-4de9-b073-350b4d9b8f28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Alamo Drafthouse Cinema South Lamar",
      "poi_type": "Entertainment",
      "poi_address": "1120 S Lamar Blvd, Austin, TX 78704, USA",
      "poi_short_description": "Stylish theater chain for new & classic films features cocktails & creative bites served seat-side.",
      "poi_long_description": "Stylish theater chain for new & classic films features cocktails & creative bites served seat-side.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-cb12-715a-95b9-657f954c53aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-cb12-715a-95b9-657f954c53aa",
        "storage_key": "property/6767906449167663/019ffd1d-cb12-715a-95b9-657f954c53aa.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://drafthouse.com/austin/theater/south-lamar",
      "poi_directions_map_url": "https://maps.google.com/?cid=1963269182035472140&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alamo-drafthouse-cinema-south-lamar",
      "poi_latitude": "30.2560666",
      "poi_longitude": "-97.7633276",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 512-861-7040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-f6ff-74aa-8cb2-df136b4bb936.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-f6ff-74aa-8cb2-df136b4bb936",
        "storage_key": "property/6767906449167663/019ffd1d-f6ff-74aa-8cb2-df136b4bb936.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0-fbEx-1RIYRDC-yUevuPhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_f8a828d2-1231-426d-b492-1b44179ef4da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Violet Crown Austin",
      "poi_type": "Entertainment",
      "poi_address": "434 W 2nd St, Austin, TX 78701, USA",
      "poi_short_description": "Locally owned cinema showing indie, documentary & foreign films, with reserved seating, bar & cafe.",
      "poi_long_description": "Locally owned cinema showing indie, documentary & foreign films, with reserved seating, bar & cafe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-bf53-7689-82f6-bfd86fa49447.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-bf53-7689-82f6-bfd86fa49447",
        "storage_key": "property/6767906449167663/019ffd1d-bf53-7689-82f6-bfd86fa49447.webp",
        "width": 1268,
        "height": 713
      },
      "poi_business_url": "https://austin.violetcrown.com/cinema",
      "poi_directions_map_url": "https://maps.google.com/?cid=15541322703931947941&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "violet-crown-austin",
      "poi_latitude": "30.2657646",
      "poi_longitude": "-97.7481387",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 737-688-0022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-f6ff-74aa-8cb2-df136b4bb936.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-f6ff-74aa-8cb2-df136b4bb936",
        "storage_key": "property/6767906449167663/019ffd1d-f6ff-74aa-8cb2-df136b4bb936.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_____1u1RIYRpbuTY6jerdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_408232c7-2ead-4dc2-ba24-eecced772c52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Thinkery",
      "poi_type": "Entertainment",
      "poi_address": "1830 Simond Ave, Austin, TX 78723, USA",
      "poi_short_description": "Interactive kids' museum with science exhibits, art, indoor & outdoor play spaces & story time.",
      "poi_long_description": "Interactive kids' museum with science exhibits, art, indoor & outdoor play spaces & story time.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-c5f6-73da-9fb0-92a8aaec7810.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-c5f6-73da-9fb0-92a8aaec7810",
        "storage_key": "property/6767906449167663/019ffd1d-c5f6-73da-9fb0-92a8aaec7810.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.thinkeryaustin.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5791177094304251559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thinkery",
      "poi_latitude": "30.297417",
      "poi_longitude": "-97.704971",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 512-469-6201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3800-748c-a486-5053ab13e008.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3800-748c-a486-5053ab13e008",
        "storage_key": "property/6767906449167663/019ffd1a-3800-748c-a486-5053ab13e008.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJgarVmgi1RIYRpz5iYeJkXlA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c3edbe7b-6eca-4818-9727-ea595803b400",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Bullock Texas State History Museum",
      "poi_type": "Entertainment",
      "poi_address": "1800 Congress Ave., Austin, TX 78701, USA",
      "poi_short_description": "Exhibits, IMAX films & educational experiences aim to tell & interpret the story of Texas.",
      "poi_long_description": "Exhibits, IMAX films & educational experiences aim to tell & interpret the story of Texas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-c918-758d-991f-bef61ed07530.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-c918-758d-991f-bef61ed07530",
        "storage_key": "property/6767906449167663/019ffd1d-c918-758d-991f-bef61ed07530.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thestoryoftexas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15204639289390306722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bullock-texas-state-history-museum",
      "poi_latitude": "30.280337",
      "poi_longitude": "-97.7390687",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 512-936-8746",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3800-748c-a486-5053ab13e008.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3800-748c-a486-5053ab13e008",
        "storage_key": "property/6767906449167663/019ffd1a-3800-748c-a486-5053ab13e008.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJzxUS9Z61RIYRopUORuC6AdM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_55e415a0-4423-4dc9-a2aa-8bc72a7defc6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Blanton Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "200 E Martin Luther King Jr Blvd, Austin, TX 78712, USA",
      "poi_short_description": "Renaissance to 20th-century American paintings, Latin American art, plus Greek & Roman sculptures.",
      "poi_long_description": "Renaissance to 20th-century American paintings, Latin American art, plus Greek & Roman sculptures.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-c848-74ce-9b69-6440dc4568e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-c848-74ce-9b69-6440dc4568e8",
        "storage_key": "property/6767906449167663/019ffd1d-c848-74ce-9b69-6440dc4568e8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://blantonmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13749455008237930349&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blanton-museum-of-art",
      "poi_latitude": "30.2808109",
      "poi_longitude": "-97.7376838",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 512-471-5482",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3800-748c-a486-5053ab13e008.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3800-748c-a486-5053ab13e008",
        "storage_key": "property/6767906449167663/019ffd1a-3800-748c-a486-5053ab13e008.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOzfaZJ61RIYRbcc8dXvgz74",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_94f571dc-4811-475c-ad6b-18dea9bfffd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Austin City Limits Live (ACL Live & 3TEN ACL Live)",
      "poi_type": "Entertainment",
      "poi_address": "310 W Willie Nelson Blvd, Austin, TX 78701, USA",
      "poi_short_description": "Austin City Limits at the Moody Theater hosts diverse performers, from Belle & Sebastian to ZZ Top.",
      "poi_long_description": "Austin City Limits at the Moody Theater hosts diverse performers, from Belle & Sebastian to ZZ Top.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-c71d-7409-b0f1-685e0dcb7df3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-c71d-7409-b0f1-685e0dcb7df3",
        "storage_key": "property/6767906449167663/019ffd1d-c71d-7409-b0f1-685e0dcb7df3.webp",
        "width": 1024,
        "height": 680
      },
      "poi_business_url": "https://acllive.com/?utm_campaign=acl&utm_medium=organicsearch&utm_source=googlemybusiness&utm_audience=tofu_googlemybusiness&utm_content=brandstory_google_my_business_website_link",
      "poi_directions_map_url": "https://maps.google.com/?cid=5268262189183100567&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "austin-city-limits-live-acl-live--3ten-acl-live",
      "poi_latitude": "30.2652627",
      "poi_longitude": "-97.7469912",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 512-404-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-383e-70b4-8c93-46c86d467817",
        "storage_key": "property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6xuoSw-1RIYRl2bhcYygHEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_8b3094c5-9b59-446f-90c9-9ddb1e5aa62c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Stubb's Bar-B-Q",
      "poi_type": "Restaurants",
      "poi_address": "801 Red River St, Austin, TX 78701, USA",
      "poi_short_description": "Beer, brisket and music Downtown with a renowned Sunday gospel brunch.",
      "poi_long_description": "Beer, brisket and music Downtown with a renowned Sunday gospel brunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-cdd7-7769-8adb-12be8a43c02f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-cdd7-7769-8adb-12be8a43c02f",
        "storage_key": "property/6767906449167663/019ffd1d-cdd7-7769-8adb-12be8a43c02f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.stubbsaustin.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10084797565243432823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stubbs-bar-b-q",
      "poi_latitude": "30.2684932",
      "poi_longitude": "-97.7362565",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 737-465-1218",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3824-769a-8093-0743cf9a42b8",
        "storage_key": "property/6767906449167663/019ffd1a-3824-769a-8093-0743cf9a42b8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSVyqJ6S1RIYRdx8PPPRl9Is",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_a1570843-2669-4194-bfb4-85dd83f4ce71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "The Paramount Theatre",
      "poi_type": "Entertainment",
      "poi_address": "713 Congress Ave, Austin, TX 78701, USA",
      "poi_short_description": "Film festivals, comedy, drama, dance, concerts & parties are all mounted in this landmark building.",
      "poi_long_description": "Film festivals, comedy, drama, dance, concerts & parties are all mounted in this landmark building.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-cc94-721f-b607-67e471494843.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-cc94-721f-b607-67e471494843",
        "storage_key": "property/6767906449167663/019ffd1d-cc94-721f-b607-67e471494843.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.austintheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18203689190063933178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-paramount-theatre",
      "poi_latitude": "30.2694668",
      "poi_longitude": "-97.742072",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 512-472-5470",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-383e-70b4-8c93-46c86d467817",
        "storage_key": "property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaci15Am1RIYR-gZh_95-oPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_0db22fc0-8cfa-4262-9662-112f67a78cfc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Saxon Pub",
      "poi_type": "Entertainment",
      "poi_address": "1320 S Lamar Blvd, Austin, TX 78704, USA",
      "poi_short_description": "Popular concert space with free weekday happy hour shows, a listening room & an intimate atmosphere.",
      "poi_long_description": "Popular concert space with free weekday happy hour shows, a listening room & an intimate atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-cbdb-736d-ace8-6d62cff237d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-cbdb-736d-ace8-6d62cff237d5",
        "storage_key": "property/6767906449167663/019ffd1d-cbdb-736d-ace8-6d62cff237d5.webp",
        "width": 1280,
        "height": 1275
      },
      "poi_business_url": "http://www.thesaxonpub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2292504141719733795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saxon-pub",
      "poi_latitude": "30.2535401",
      "poi_longitude": "-97.7635794",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 512-448-2552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-383e-70b4-8c93-46c86d467817",
        "storage_key": "property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz_9V9Qm1RIYRIwZR5V6c0B8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_e9032031-5b57-42b4-a6cb-efe11f1b0cd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "St. David's South Austin Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "901 W Ben White Blvd, Austin, TX 78704, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd19-f637-71ab-aa3c-554284aaff39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd19-f637-71ab-aa3c-554284aaff39",
        "storage_key": "property/6767906449167663/019ffd19-f637-71ab-aa3c-554284aaff39.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.stdavids.com/locations/st-davids-south-austin-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17650142985562363979&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-davids-south-austin-medical-center",
      "poi_latitude": "30.2260391",
      "poi_longitude": "-97.7745692",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 512-447-2211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3801-7652-a7be-aed076071f5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3801-7652-a7be-aed076071f5d",
        "storage_key": "property/6767906449167663/019ffd1a-3801-7652-a7be-aed076071f5d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_47yiLe0RIYRSxhM6Yfn8fQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_c7db0b4a-168f-4ffa-af06-7a1ee240ce96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Concentra Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "2171 Woodward St, Austin, TX 78744, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-d020-71e8-be59-bbbdfb771981.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-d020-71e8-be59-bbbdfb771981",
        "storage_key": "property/6767906449167663/019ffd1d-d020-71e8-be59-bbbdfb771981.webp",
        "width": 728,
        "height": 351
      },
      "poi_business_url": "https://www.concentra.com/urgent-care-centers/texas/austin/austin-airport-urgent-care/#nearbylocations_g=30.2124476471%7C-97.7462833042&nearbylocations_o=DistanceMi%2CAscending&nearbylocations_distancemi=20&nearbylocations_DistanceMi=20",
      "poi_directions_map_url": "https://maps.google.com/?cid=5136631449436068361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concentra-urgent-care",
      "poi_latitude": "30.2125134",
      "poi_longitude": "-97.7465006",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 512-610-3001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-383e-70b4-8c93-46c86d467817",
        "storage_key": "property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkUiKS4G0RIYRCZq8lRb7SEc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_aab7b90a-5ae4-473e-9708-9352946cb2ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Lumos Fitness Collective",
      "poi_type": "Health and Wellness",
      "poi_address": "2415 Burleson Rd, Austin, TX 78741, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-d205-7321-bb77-01ee67632a38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-d205-7321-bb77-01ee67632a38",
        "storage_key": "property/6767906449167663/019ffd1d-d205-7321-bb77-01ee67632a38.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.lumosfitnesscollective.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17612667579373629847&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lumos-fitness-collective",
      "poi_latitude": "30.2290234",
      "poi_longitude": "-97.7352976",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 512-883-4036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-383e-70b4-8c93-46c86d467817",
        "storage_key": "property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd3RxSGe0RIYRl7Ga99jDbPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_406f65ac-7bb7-4b4d-b528-6170cd66e51a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Crunch Fitness - Austin Southpark Meadows",
      "poi_type": "Health and Wellness",
      "poi_address": "9900 S I-35 Frontage Rd Suite H, Austin, TX 78748, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-d2f5-757b-92f8-eece16caaf9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-d2f5-757b-92f8-eece16caaf9d",
        "storage_key": "property/6767906449167663/019ffd1d-d2f5-757b-92f8-eece16caaf9d.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://www.crunch.com/locations/south-park-meadows",
      "poi_directions_map_url": "https://maps.google.com/?cid=16057579063337203112&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crunch-fitness---austin-southpark-meadows",
      "poi_latitude": "30.1575853",
      "poi_longitude": "-97.7943218",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 32 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 512-800-6140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-383e-70b4-8c93-46c86d467817",
        "storage_key": "property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG8qshPJNW4YRqLX21hT7194",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0e161cbf-f565-475f-80a7-cf68b518df67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "9900 S I-35 Frontage Rd Building M Suite A300, Austin, TX 78748, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-d4c0-70bd-ac50-ca05bc9776ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-d4c0-70bd-ac50-ca05bc9776ba",
        "storage_key": "property/6767906449167663/019ffd1d-d4c0-70bd-ac50-ca05bc9776ba.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://clubpilates.com/southparkmeadows/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=4290521216846923177&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "30.1580416",
      "poi_longitude": "-97.7916313",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 737-600-1516",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3829-75c9-83fe-b255894aac29",
        "storage_key": "property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5c_k8JNNW4YRqQVwh1D-ijs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a595f32f-6309-42bc-a514-e68d7d173b22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Black Swan Yoga - Westgate",
      "poi_type": "Health and Wellness",
      "poi_address": "4534 West Gate Blvd, Austin, TX 78745, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-d780-701f-93ad-e69ce234d4fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-d780-701f-93ad-e69ce234d4fe",
        "storage_key": "property/6767906449167663/019ffd1d-d780-701f-93ad-e69ce234d4fe.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.blackswanyoga.com/healcode/westgate-book",
      "poi_directions_map_url": "https://maps.google.com/?cid=10082803993043690009&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-swan-yoga---westgate",
      "poi_latitude": "30.2310216",
      "poi_longitude": "-97.803519",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 512-960-4026",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3829-75c9-83fe-b255894aac29",
        "storage_key": "property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJReAKhRO1RIYRGWJCic9Q7Ys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_7ce7cee3-80c8-4546-a78d-1b6417dafd10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "2501 S Lamar Blvd, Austin, TX 78704, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-d4c1-77b1-9706-695b5d0848c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-d4c1-77b1-9706-695b5d0848c6",
        "storage_key": "property/6767906449167663/019ffd1d-d4c1-77b1-9706-695b5d0848c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2501+s+lamar+blvd-austin-tx-78704/id=1933",
      "poi_directions_map_url": "https://maps.google.com/?cid=11862847006546498492&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "30.2460507",
      "poi_longitude": "-97.777741",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 512-443-7534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-383e-70b4-8c93-46c86d467817",
        "storage_key": "property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1xJzItO0RIYRvJMCGoBMoaQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_8f1b7a45-5335-46d5-bcab-1bcc34205115",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "8801 S Congress Ave, Austin, TX 78745, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-d715-76db-931b-6c42e5b4c3b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-d715-76db-931b-6c42e5b4c3b8",
        "storage_key": "property/6767906449167663/019ffd1d-d715-76db-931b-6c42e5b4c3b8.webp",
        "width": 986,
        "height": 554
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/austin/slaughter-and-south-congress-h-e-b-710?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=15459873841222913355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "30.1682327",
      "poi_longitude": "-97.7875538",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 737-236-8348",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3805-7508-b498-6cae143dd655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3805-7508-b498-6cae143dd655",
        "storage_key": "property/6767906449167663/019ffd1a-3805-7508-b498-6cae143dd655.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJje0yKK9NW4YRSw1yQlmBjNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_db17da94-b985-4ed2-9bae-33672521c004",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "St. David's Emergency Center - Circle C, a department of St. David's South Austin Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "5701 W Slaughter Ln g101, Austin, TX 78749, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-d84f-757e-858e-6ad933c6d7dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-d84f-757e-858e-6ad933c6d7dd",
        "storage_key": "property/6767906449167663/019ffd1d-d84f-757e-858e-6ad933c6d7dd.webp",
        "width": 1000,
        "height": 609
      },
      "poi_business_url": "https://www.stdavids.com/locations/st-davids-emergency-center-circle-c?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13603871390670875409&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-davids-emergency-center---circle-c-a-department-of-st-davids-south-austin-medical-center",
      "poi_latitude": "30.2003948",
      "poi_longitude": "-97.8686691",
      "poi_miles_from_property": "13.2",
      "poi_walking_minutes": "4 hours 57 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 512-651-5787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-383e-70b4-8c93-46c86d467817",
        "storage_key": "property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdb75nP9LW4YREWsJE_Soyrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_ccf2cc26-6209-4050-8d1e-c97b79f60d32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Country Club Creek Greenbelt",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3109 Burleson Rd, Austin, TX 78741, USA",
      "poi_short_description": "Kid-friendly hiking area also popular with dog owners.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-db6a-775a-a031-be42919c61ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-db6a-775a-a031-be42919c61ac",
        "storage_key": "property/6767906449167663/019ffd1d-db6a-775a-a031-be42919c61ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.austintexas.gov/department/parks-and-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=12107089677323993784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "country-club-creek-greenbelt",
      "poi_latitude": "30.2202118",
      "poi_longitude": "-97.7313311",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 512-974-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-f71f-733b-97df-8b76bc4ad136.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-f71f-733b-97df-8b76bc4ad136",
        "storage_key": "property/6767906449167663/019ffd1d-f71f-733b-97df-8b76bc4ad136.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8aUGF2W0RIYRuAKyWOoFBag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_7bf36128-c2af-4bad-8590-a7ce50b57e76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Onion Creek Greenbelt",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7002 Onion Creek Dr, Austin, TX 78744, USA",
      "poi_short_description": "555-acre regional park with an off-leash dog policy, pond & recreation trails for hiking & walks.",
      "poi_long_description": "555-acre regional park with an off-leash dog policy, pond & recreation trails for hiking & walks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-db22-722d-ad53-56b7287382f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-db22-722d-ad53-56b7287382f9",
        "storage_key": "property/6767906449167663/019ffd1d-db22-722d-ad53-56b7287382f9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.austintexas.gov/department/parks-and-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=10442410290158869758&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "onion-creek-greenbelt",
      "poi_latitude": "30.1684558",
      "poi_longitude": "-97.7532143",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 512-974-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3805-7508-b498-68eaebdbb182.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3805-7508-b498-68eaebdbb182",
        "storage_key": "property/6767906449167663/019ffd1a-3805-7508-b498-68eaebdbb182.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJrROBsgWzRIYR_pzNJ9Xk6pA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9ed2fff5-f49c-4816-ae60-f77f2a94a5e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Richard Moya Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10001 Burleson Rd, Austin, TX 78719, USA",
      "poi_short_description": "Leafy park with a well-known bridge, plus a playground, basketball court & ball fields.",
      "poi_long_description": "Leafy park with a well-known bridge, plus a playground, basketball court & ball fields.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-db2b-753d-9cb0-229687220deb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-db2b-753d-9cb0-229687220deb",
        "storage_key": "property/6767906449167663/019ffd1d-db2b-753d-9cb0-229687220deb.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://parks.traviscountytx.gov/parks/richard-moya",
      "poi_directions_map_url": "https://maps.google.com/?cid=1522051760029106253&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richard-moya-park",
      "poi_latitude": "30.1699655",
      "poi_longitude": "-97.6699483",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 512-854-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3805-7508-b498-68eaebdbb182.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3805-7508-b498-68eaebdbb182",
        "storage_key": "property/6767906449167663/019ffd1a-3805-7508-b498-68eaebdbb182.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq5U0mg6xRIYRTQBL9gJqHxU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3b6d6aff-7209-4597-be37-98f4c7d410a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Skyline Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7800 Apogee Blvd, Austin, TX 78744, USA",
      "poi_short_description": "Spacious playground featuring swings, slides, a splash pad, a zip line and picnic tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-dcf8-7768-a824-f7cbd4de3262.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-dcf8-7768-a824-f7cbd4de3262",
        "storage_key": "property/6767906449167663/019ffd1d-dcf8-7768-a824-f7cbd4de3262.webp",
        "width": 1280,
        "height": 800
      },
      "poi_business_url": "http://www.eastonparkatx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10082273059220983140&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "skyline-park",
      "poi_latitude": "30.1513657",
      "poi_longitude": "-97.7156335",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 512-580-7278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3805-7508-b498-68eaebdbb182.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3805-7508-b498-68eaebdbb182",
        "storage_key": "property/6767906449167663/019ffd1a-3805-7508-b498-68eaebdbb182.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJhUlfgzuzRIYRZI1b3-1t64s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_47d2f4f3-1465-4d2b-8fe5-60ec64f74a3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Kendra Page Neighborhood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Blue Meadow Dr, Austin, TX 78744, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-e0da-70c9-977f-60613a719727.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-e0da-70c9-977f-60613a719727",
        "storage_key": "property/6767906449167663/019ffd1d-e0da-70c9-977f-60613a719727.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3020489579648967925&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kendra-page-neighborhood-park",
      "poi_latitude": "30.18003479999999",
      "poi_longitude": "-97.7641629",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3805-7508-b498-68eaebdbb182.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3805-7508-b498-68eaebdbb182",
        "storage_key": "property/6767906449167663/019ffd1a-3805-7508-b498-68eaebdbb182.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdaPdMj6zRIYR9eS--kTv6ik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_97a0126e-3d4e-44d5-8c65-d5aff59fdcef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Onion Creek Metropolitan Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8652 Nuckols Crossing Rd, Austin, TX 78744, USA",
      "poi_short_description": "Wooded, flat, largely undeveloped 555-acre regional park including small ponds & rough trails.",
      "poi_long_description": "Wooded, flat, largely undeveloped 555-acre regional park including small ponds & rough trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-e020-73ba-b8bc-31a67600d8c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-e020-73ba-b8bc-31a67600d8c5",
        "storage_key": "property/6767906449167663/019ffd1d-e020-73ba-b8bc-31a67600d8c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.austintexas.gov/page/park-directory#o",
      "poi_directions_map_url": "https://maps.google.com/?cid=6877902690062635321&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "onion-creek-metropolitan-park",
      "poi_latitude": "30.1585556",
      "poi_longitude": "-97.7554397",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 512-974-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3805-7508-b498-68eaebdbb182.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3805-7508-b498-68eaebdbb182",
        "storage_key": "property/6767906449167663/019ffd1a-3805-7508-b498-68eaebdbb182.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJqTwwUxyzRIYRORHjUA44c18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4065550e-27ed-41aa-aaca-71b977339ba5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "McKinney Falls State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5808 McKinney Falls Pkwy, Austin, TX 78744, USA",
      "poi_short_description": "Popular site for camping, hiking, biking & fishing, & for \"Old Baldy,\" a 500+-year-old cypress tree.",
      "poi_long_description": "Popular site for camping, hiking, biking & fishing, & for \"Old Baldy,\" a 500+-year-old cypress tree.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd19-f948-7693-89cb-d0313c71e939.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd19-f948-7693-89cb-d0313c71e939",
        "storage_key": "property/6767906449167663/019ffd19-f948-7693-89cb-d0313c71e939.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tpwd.texas.gov/state-parks/mckinney-falls",
      "poi_directions_map_url": "https://maps.google.com/?cid=18123339836864710291&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckinney-falls-state-park",
      "poi_latitude": "30.1836487",
      "poi_longitude": "-97.7221944",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 512-243-1643",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3805-7508-b498-68eaebdbb182.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3805-7508-b498-68eaebdbb182",
        "storage_key": "property/6767906449167663/019ffd1a-3805-7508-b498-68eaebdbb182.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJi7M4Nb6zRIYRk8YBYI8Jg_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_feda3375-e48b-41f4-b84a-747bd105c8a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Jimmy Clay Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5400 Jimmy Clay Dr, Austin, TX 78744, USA",
      "poi_short_description": "Golf course featuring practice facilities, a driving range and a snack bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-0dff-76f8-97a8-e8ed5103c374.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-0dff-76f8-97a8-e8ed5103c374",
        "storage_key": "property/6767906449167663/019ffd1a-0dff-76f8-97a8-e8ed5103c374.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.austintexas.gov/department/jimmy-clay-course",
      "poi_directions_map_url": "https://maps.google.com/?cid=9609639449316418114&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jimmy-clay-golf-course",
      "poi_latitude": "30.1853271",
      "poi_longitude": "-97.7322916",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 512-974-4653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3840-7228-9cbb-116a9316727f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3840-7228-9cbb-116a9316727f",
        "storage_key": "property/6767906449167663/019ffd1a-3840-7228-9cbb-116a9316727f.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJMQgwv6KzRIYRQuIVRCpMXIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_2bd50384-98ae-4ced-9dab-a49b2a8737cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Longhorn Shores at Town Lake Metropolitan Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "60 S Pleasant Valley Rd, Austin, TX 78741, USA",
      "poi_short_description": "Park with picnic tables, and a public restroom, as well as hiking and biking trails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-e33e-700f-948c-45b2989d25e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-e33e-700f-948c-45b2989d25e8",
        "storage_key": "property/6767906449167663/019ffd1d-e33e-700f-948c-45b2989d25e8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11151089366155484372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "longhorn-shores-at-town-lake-metropolitan-park",
      "poi_latitude": "30.2470472",
      "poi_longitude": "-97.7148917",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 512-974-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3805-7508-b498-68eaebdbb182.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3805-7508-b498-68eaebdbb182",
        "storage_key": "property/6767906449167663/019ffd1a-3805-7508-b498-68eaebdbb182.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvx5d5ie1RIYR1FxVkLKgwJo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2b976318-c43d-4fa0-ae8d-e8074ae04c08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Blunn Creek Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1200 St Edwards Dr, Austin, TX 78704, USA",
      "poi_short_description": "Trail system, nature preserve featuring creeks, trees and an extinct volcano.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-e1be-708e-9d1c-17e8d6d35e51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-e1be-708e-9d1c-17e8d6d35e51",
        "storage_key": "property/6767906449167663/019ffd1d-e1be-708e-9d1c-17e8d6d35e51.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.austintexas.gov/page/park-directory",
      "poi_directions_map_url": "https://maps.google.com/?cid=10872948146596008856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blunn-creek-nature-preserve",
      "poi_latitude": "30.2328939",
      "poi_longitude": "-97.7473141",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 512-974-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3805-7508-b498-68eaebdbb182.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3805-7508-b498-68eaebdbb182",
        "storage_key": "property/6767906449167663/019ffd1a-3805-7508-b498-68eaebdbb182.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVNQV1a0RIYRmNMYY7t45JY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_385ca1b4-6111-4703-8fca-ba690b7d7893",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Austin-Bergstrom International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3600 Presidential Blvd, Austin, TX 78719, USA",
      "poi_short_description": "Austin-area airport featuring regular live-music performances & numerous artworks.",
      "poi_long_description": "Austin-area airport featuring regular live-music performances & numerous artworks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-0f92-7479-bd34-d83777489a90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-0f92-7479-bd34-d83777489a90",
        "storage_key": "property/6767906449167663/019ffd1a-0f92-7479-bd34-d83777489a90.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.austintexas.gov/airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=2064896756044015464&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "austin-bergstrom-international-airport",
      "poi_latitude": "30.194085",
      "poi_longitude": "-97.6710889",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 512-530-2242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-37fa-7273-a784-2398315016ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-37fa-7273-a784-2398315016ea",
        "storage_key": "property/6767906449167663/019ffd1a-37fa-7273-a784-2398315016ea.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJRf9KizuxRIYRaCfcyaj8pxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_0973a70f-54c8-466a-bfaf-d5b378ddec8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Rental Car Facility (CONRAC)",
      "poi_type": "Transportation & Transit",
      "poi_address": "3600 Presidential Blvd, Austin, TX 78719, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-e658-74bc-8cb5-6d66113340e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-e658-74bc-8cb5-6d66113340e4",
        "storage_key": "property/6767906449167663/019ffd1d-e658-74bc-8cb5-6d66113340e4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4718673814700536642&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rental-car-facility-conrac",
      "poi_latitude": "30.2043288",
      "poi_longitude": "-97.6662716",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-f6fa-72ee-ac3b-cefda5245524.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-f6fa-72ee-ac3b-cefda5245524",
        "storage_key": "property/6767906449167663/019ffd1d-f6fa-72ee-ac3b-cefda5245524.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJtRhB3TGxRIYRQrMpeNUYfEE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "car_rental"
    },
    {
      "id": "custom_39ca1434-5677-4f45-8ffa-ca0dd6855249",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "South Congress Transit Center, Capital Metro",
      "poi_type": "Transportation & Transit",
      "poi_address": "300 Radam Ln, Austin, TX 78704, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-e407-725b-8895-5b364965ae62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-e407-725b-8895-5b364965ae62",
        "storage_key": "property/6767906449167663/019ffd1d-e407-725b-8895-5b364965ae62.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://capmetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1149775063840403001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-congress-transit-center-capital-metro",
      "poi_latitude": "30.2225927",
      "poi_longitude": "-97.7668531",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-383e-70b4-8c93-46c86d467817",
        "storage_key": "property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrwPBhr60RIYROS7PK1TS9A8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_43dc440a-5ec8-446c-8c9c-9c33ff79a85f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Greyhound: Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "363 Shady Ln, Austin, TX 78702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-e606-75de-8cbe-94b1d07b47c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-e606-75de-8cbe-94b1d07b47c7",
        "storage_key": "property/6767906449167663/019ffd1d-e606-75de-8cbe-94b1d07b47c7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greyhound.com/bus/austin-tx/austin-eastside-bus-plaza?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=448900343737329614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-station",
      "poi_latitude": "30.2516609",
      "poi_longitude": "-97.6979091",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-383e-70b4-8c93-46c86d467817",
        "storage_key": "property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ06MUvhfKRIYRzqcD-HvQOgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_055c189e-b9bc-4100-88f8-9e167ebb0f63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Flix Bus station",
      "poi_type": "Transportation & Transit",
      "poi_address": "703 E 9th St, Austin, TX 78701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-e743-703b-ae49-4bb1100be3f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-e743-703b-ae49-4bb1100be3f8",
        "storage_key": "property/6767906449167663/019ffd1d-e743-703b-ae49-4bb1100be3f8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://flixbus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13157170146154343659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flix-bus-station",
      "poi_latitude": "30.2685633",
      "poi_longitude": "-97.7342389",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-383e-70b4-8c93-46c86d467817",
        "storage_key": "property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9RpwhF-1RIYR62znyomol7Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_9564c5bf-b821-4d16-a2e0-60b99cdac3eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Amtrak Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "250 N Lamar Blvd, Austin, TX 78703, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-ebd7-760b-8d87-dfd76d35d094.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-ebd7-760b-8d87-dfd76d35d094",
        "storage_key": "property/6767906449167663/019ffd1d-ebd7-760b-8d87-dfd76d35d094.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.amtrak.com/stations/aus",
      "poi_directions_map_url": "https://maps.google.com/?cid=10877763737090700583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amtrak-station",
      "poi_latitude": "30.2696097",
      "poi_longitude": "-97.7570145",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 866-332-1235",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-383e-70b4-8c93-46c86d467817",
        "storage_key": "property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX9bOLQC1RIYRJ7Xqa3yU9ZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_de5a81b1-dbd9-446a-a837-c403fb7a2b73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Downtown Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "209 E 4th St, Austin, TX 78701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-ebec-7628-b338-968c7fb9d2e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-ebec-7628-b338-968c7fb9d2e2",
        "storage_key": "property/6767906449167663/019ffd1d-ebec-7628-b338-968c7fb9d2e2.webp",
        "width": 1280,
        "height": 835
      },
      "poi_business_url": "https://www.capmetro.org/metrorail/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10271172265341142529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-station",
      "poi_latitude": "30.264869",
      "poi_longitude": "-97.7384633",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-f707-737b-b5b3-c7b72f70e48a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-f707-737b-b5b3-c7b72f70e48a",
        "storage_key": "property/6767906449167663/019ffd1d-f707-737b-b5b3-c7b72f70e48a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJZSVW0ae1RIYRAcaAnsGIio4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tram_stop"
    },
    {
      "id": "custom_40507b65-fdf2-4b09-ab15-325534627c92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Tesla Giga Texas",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Tesla Rd, Austin, TX 78725, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-eabc-7214-8747-2a2e78a0772c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-eabc-7214-8747-2a2e78a0772c",
        "storage_key": "property/6767906449167663/019ffd1d-eabc-7214-8747-2a2e78a0772c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tesla.com/giga-texas",
      "poi_directions_map_url": "https://maps.google.com/?cid=8044261432942276074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tesla-giga-texas",
      "poi_latitude": "30.2248156",
      "poi_longitude": "-97.619548",
      "poi_miles_from_property": "11.7",
      "poi_walking_minutes": "4 hours 14 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 512-516-8177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-383e-70b4-8c93-46c86d467817",
        "storage_key": "property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJedYjPy3RIYR6i3mJif1om8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8f784a6d-58dc-49ab-b58a-7a16967770cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Austin VA Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "7901 Metropolis Dr, Austin, TX 78744, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-eb78-7617-a121-4380da0f5505.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-eb78-7617-a121-4380da0f5505",
        "storage_key": "property/6767906449167663/019ffd1d-eb78-7617-a121-4380da0f5505.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.centraltexas.va.gov/locations/Austin.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=3796071553800682935&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "austin-va-clinic",
      "poi_latitude": "30.2059901",
      "poi_longitude": "-97.6898976",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-423-2111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-383e-70b4-8c93-46c86d467817",
        "storage_key": "property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwQEgylOxRIYRtz1BOvdarjQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_2b81b91d-3dbb-40ba-8cdc-8337e9447de9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Dell Seton Medical Center at The University of Texas",
      "poi_type": "Health and Wellness",
      "poi_address": "1500 Red River St, Austin, TX 78701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-ebc9-7346-a86b-206dd7d1f91b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-ebc9-7346-a86b-206dd7d1f91b",
        "storage_key": "property/6767906449167663/019ffd1d-ebc9-7346-a86b-206dd7d1f91b.webp",
        "width": 1200,
        "height": 976
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/texas/txaus/austin-dell-seton-medical-center-at-the-university-of-texas?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1180798402976466894&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dell-seton-medical-center-at-the-university-of-texas",
      "poi_latitude": "30.27651",
      "poi_longitude": "-97.73383520000002",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 512-324-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3801-7652-a7be-aed076071f5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3801-7652-a7be-aed076071f5d",
        "storage_key": "property/6767906449167663/019ffd1a-3801-7652-a7be-aed076071f5d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJV1Wle6K1RIYRzsfCMOQJYxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0360d457-79f2-4c9a-90df-e7c6f283660b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "The University of Texas at Austin Main Building (MAI)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "110 Inner Campus Drive, Austin, TX 78712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-f0fd-729c-b020-304270a9a2b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-f0fd-729c-b020-304270a9a2b2",
        "storage_key": "property/6767906449167663/019ffd1d-f0fd-729c-b020-304270a9a2b2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.utexas.edu/contact-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=4722211475644395459&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-university-of-texas-at-austin-main-building-mai",
      "poi_latitude": "30.2863291",
      "poi_longitude": "-97.7393046",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 512-471-3434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-383e-70b4-8c93-46c86d467817",
        "storage_key": "property/6767906449167663/019ffd1a-383e-70b4-8c93-46c86d467817.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjW9sIp21RIYRw68OWFGqiEE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_feffa4cc-191c-4059-a5af-c42c2d15b2b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Austin State Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4110 Guadalupe St, Austin, TX 78751, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-f055-76e8-bb42-bba7f35cf290.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-f055-76e8-bb42-bba7f35cf290",
        "storage_key": "property/6767906449167663/019ffd1d-f055-76e8-bb42-bba7f35cf290.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hhs.texas.gov/services/mental-health-substance-use/state-hospitals/austin-state-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=11513972469001748839&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "austin-state-hospital",
      "poi_latitude": "30.3097335",
      "poi_longitude": "-97.7378387",
      "poi_miles_from_property": "11",
      "poi_walking_minutes": "4 hours 7 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 512-452-0381",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3801-7652-a7be-aed076071f5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3801-7652-a7be-aed076071f5d",
        "storage_key": "property/6767906449167663/019ffd1a-3801-7652-a7be-aed076071f5d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJXXYIXnvKRIYRZwF6-PTYyZ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0fd487ac-051a-48e0-8536-6aacecc1a527",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Austin Community College: South Austin Campus",
      "poi_type": "Education",
      "poi_address": "1820 W Stassney Ln, Austin, TX 78745, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd19-e881-719c-b691-bd2781f42129.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd19-e881-719c-b691-bd2781f42129",
        "storage_key": "property/6767906449167663/019ffd19-e881-719c-b691-bd2781f42129.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.austincc.edu/sac",
      "poi_directions_map_url": "https://maps.google.com/?cid=5650834027332857399&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "austin-community-college-south-austin-campus",
      "poi_latitude": "30.2150835",
      "poi_longitude": "-97.7964636",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 512-223-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3829-75c9-83fe-b255894aac29",
        "storage_key": "property/6767906449167663/019ffd1a-3829-75c9-83fe-b255894aac29.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc-ycVUVLW4YRN27dw5vLa04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_040e3934-bf50-43d0-bc7b-9e9fcb8cc524",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "poi_name": "Travis County",
      "poi_type": "Major Employers & Offices",
      "poi_address": "700 Lavaca St, Austin, TX 78701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1d-f0e5-7135-92fa-51a10fbda7f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-f0e5-7135-92fa-51a10fbda7f1",
        "storage_key": "property/6767906449167663/019ffd1d-f0e5-7135-92fa-51a10fbda7f1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.traviscountytx.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6794741471232961647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "travis-county",
      "poi_latitude": "30.2702889",
      "poi_longitude": "-97.7452273",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 512-854-9020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-3aa6-7646-b686-fc654b31c1e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-3aa6-7646-b686-fc654b31c1e5",
        "storage_key": "property/6767906449167663/019ffd1a-3aa6-7646-b686-fc654b31c1e5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh21x2Au1RIYRb6x0NV7FS14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_de613c9d42f6e8c981e306e5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c63482ea92209def94d7d2ec",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_1b779928c99371e0d9864d04",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_654d0830c4c60bd03f89d180",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c3c04d3643698e2f90bf22e2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_1896ef9eeb9b6767f8a2289e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_899d18a2fede2c966bfa18de",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "rating": "5",
      "name": "Michelle Hazelwood",
      "text": "I just wanted to take a moment to recognize our amazing maintenance team because they don’t always receive the appreciation they deserve.\n\nI submitted a maintenance request, and John was here the very next day, bringing Miguel and Julian along to help. These gentlemen were professional, respectful, and worked diligently to make sure everything was completed the right way.\n\nAs someone who lives alone and doesn’t have many resources, it’s incredibly reassuring to know we have a maintenance team that genuinely cares and makes sure things are taken care of promptly and properly.\n\nThank you, John, Miguel, and Julian, for your hard work and dedication. Your efforts do not go unnoticed and are truly appreciated!",
      "date": "2026-07-21",
      "title": "false"
    },
    {
      "id": "ec_ba457a641956de07f32cefa2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "rating": "4",
      "name": "Sam Rodriguez",
      "text": "I’ve truly loved living here and being one of the very first residents to move into this community has made the experience even more special. Since day one, the staff and management team have always been incredibly friendly, welcoming, and helpful. They’ve done such a great job creating an environment that feels peaceful, private, and comfortable while still having a fun and warm community atmosphere.\n\nMy unit has been amazing — clean, well-maintained, and a place I’ve genuinely enjoyed calling home. I’ve always felt safe here, and it’s been such a nice place to come back to after long days. It’s been really cool watching the community grow over time while still keeping that friendly and caring feeling. I’m very grateful for my experience living here and would absolutely recommend these apartments to anyone looking for a beautiful and comfortable place to live.",
      "date": "2026-05-27",
      "title": "false"
    },
    {
      "id": "ec_f6a8bd3d74f29a77e21b5bb2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "rating": "5",
      "name": "Colton Ashabranner",
      "text": "I recently toured Hangar at Bergstrom and had an incredible experience from start to finish. Arny was my leasing agent and honestly blew me away. He was knowledgeable, patient, and answered every single question I had without hesitation. You can tell he genuinely cares about finding the right fit for people, not just filling units.\n\nThe property itself is beautiful and well-kept, but Arny's professionalism and warm personality really made the visit stand out. I left feeling confident and excited about the community. If you're considering touring, ask for Arny! You won't be disappointed.",
      "date": "2026-06-12",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_be7d5905-bcca-4134-a55c-3aaabb65d44e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167663/019ffd1a-a142-72cc-88fb-6eaa0067b3dc.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ffd1a-a142-72cc-88fb-6eaa0067b3dc",
        "storage_key": "property/6767906449167663/019ffd1a-a142-72cc-88fb-6eaa0067b3dc.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "The Hangar at Bergstrom",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=69cc27ddba186e7bb4e80b39&sourceId=1001"
    }
  ],
  "faqs": [
    {
      "id": "custom_c3dd035f-1e70-422a-89df-f8124965c9c9",
      "question": "What is the best neighborhood to rent an apartment in Austin?",
      "answer": "Austin has many distinct neighborhoods to choose from and has something for everyone. Here are some of the best places to live when you're looking for an Austin apartment for rent:\n\nSoutheast Austin\nThe Hangar at Bergstrom is perfectly positioned in this rapidly growing area, which offers a unique blend of natural landscapes and swift access to urban conveniences. Residents enjoy being minutes from Austin-Bergstrom International Airport and beautiful state parks.\n\nDowntown Austin\nThis energetic corporate and entertainment hub features high-rise living alongside a legendary live music scene. It's ideal for those who want a dense, walkable city lifestyle close to major employers and nightlife.\n\nSouth Congress\nKnown for its historic charm and vibrant culture, this walkable neighborhood is lined with eclectic boutiques, vintage shops, and popular local eateries. It attracts renters looking for an artistic and pedestrian-friendly community.\n\nEast Austin\nThis trendy neighborhood balances rich cultural history with modern innovation, showcasing a diverse culinary scene and unique cocktail lounges. The area is a favorite destination for young professionals and creatives.",
      "category": "",
      "source": "custom"
    },
    {
      "id": "custom_8d6e1916-66ba-4e89-b393-32064439e1fb",
      "question": "What makes living in Austin, Texas unique?",
      "answer": "Austin offers a thriving economic landscape with access to exceptional outdoor recreation and culture. Whether you're looking for tech career opportunities, famous live music, or beautiful riverside trails, here are some of the unique features to consider:\n\nIdeal Location\nExperience the convenience of a connected South Austin lifestyle at The Hangar at Bergstrom. Ideally located near Burleson Road with quick access to Highway 71 and US-183, our community places you just minutes from Austin-Bergstrom International Airport, Downtown Austin, major employers, shopping, dining, and local entertainment. Whether you're commuting to work, catching a flight, or exploring everything Austin has to offer, The Hangar at Bergstrom makes getting where you need to go effortless.\n\nOutdoor Adventures\nEmbrace the best of Austin's outdoor lifestyle with recreation just moments from home. Residents enjoy direct trail access from the community, making it easy to walk, run, or bike without ever leaving the neighborhood. Explore the scenic beauty of nearby McKinney Falls State Park, spend the day along the Barton Creek Greenbelt, or cool off at the iconic Barton Springs Pool in Zilker Park. From hiking and cycling to kayaking, swimming, and nature escapes, The Hangar at Bergstrom places you close to some of Austin's most celebrated outdoor destinations.\n\nPremium Living\nHighlighting its exceptional quality of life, U.S. News & World Report ranked Austin the number nine best place to live in the United States for 2024–2025.\n\nLocal Community\nDiscover the energy and character that make Southeast Austin one of the city's most desirable places to call home. Just minutes from Downtown Austin, The Hangar at Bergstrom offers convenient access to renowned live music venues, acclaimed restaurants, local breweries, eclectic food trucks, and vibrant entertainment districts. Explore neighborhood coffee shops, colorful murals, farmers markets, and community events, or spend the day kayaking on Lady Bird Lake and experiencing Austin's celebrated outdoor lifestyle. With a blend of creative culture, urban convenience, and authentic local charm, The Hangar at Bergstrom places you at the center of everything that makes Austin exceptional.",
      "category": "",
      "source": "custom"
    },
    {
      "id": "custom_f582aa88-6d0d-492e-9052-3163d7518ee5",
      "question": "What are some things to do in Austin, Texas?",
      "answer": "There are many fun activities to do in Austin! The Hangar at Bergstrom's location in vibrant Southeast Austin puts residents in the heart of a rapidly evolving entertainment and recreation area. Major attractions in the area include:\n\n- McKinney Falls State Park\n- Texas State Capitol\n- Barton Springs Pool\n- Lady Bird Lake Hike-and-Bike Trail\n- Zilker Metropolitan Park\n- South Congress Avenue\n- Blanton Museum of Art\n- Moody Center",
      "category": "",
      "source": "custom"
    },
    {
      "id": "custom_b24c177d-7eee-421e-978b-c594e39b3937",
      "question": "How close is Austin to major employers?",
      "answer": "The Hangar at Bergstrom is only minutes from Austin's top employers. The property's proximity to major local highways gives easy access to technology, healthcare, education, and government employers, like:\n\n- Tesla Gigafactory Texas\n- Oracle\n- Apple\n- Dell Technologies, headquarters in nearby Round Rock\n- Ascension Seton\n- University of Texas at Austin\n- State of Texas\n- St. David's HealthCare\n- Amazon",
      "category": "",
      "source": "custom"
    },
    {
      "id": "custom_34dffbaf-b73c-4b0a-b345-f54d58cb4c42",
      "question": "What amenities does The Hangar at Bergstrom offer?",
      "answer": "At The Hangar at Bergstrom, you'll find a variety of amenities that make living in dynamic Austin even better, such as:\n\nGourmet Kitchens with Quartz Countertops and Stainless Steel Appliances\nYour home becomes the ultimate culinary sanctuary with premium finishes, modern glass cooktops, and spacious kitchen islands designed for effortless hosting.\n\nResort-Style Swimming Pool with a Lounging Edge and Poolside Grills\nThis vibrant outdoor oasis serves as the perfect backdrop for soaking up the Texas sun and enjoying evening cookouts with your neighbors.\n\nFully Equipped Co-Working Business Spaces and 24/7 High-Tech Fitness Center\nThe Hangar at Bergstrom residents enjoy the ultimate blend of work-life balance with semi-private workspaces and a state-of-the-art gym available on your own schedule.\n\nDedicated Pet Park with Night Lighting and Direct Nature Trail Access\nLiving at The Hangar at Bergstrom means you and your four-legged companions can comfortably embrace an active lifestyle amidst beautiful, serene surroundings.",
      "category": "",
      "source": "custom"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a04a29-4a0e-7529-88df-bb2ba4ec83c3",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Hangar at Bergstrom Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663"
    },
    {
      "lead_collector_id": "01a04a29-4a91-7363-94f9-a481a7a57d83",
      "lead_source": "LANDING_PAGE",
      "name": "Hangar at Bergstrom Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "generator",
      "page_item_url": "apartments-swimming-pool-austin-tx",
      "search_query": "apartments with swimming pool Austin TX",
      "category": "Amenity",
      "h1_title": "Apartments with Swimming Pool in Austin, TX",
      "h2_subtitle": "Explore our apartments with a refreshing swimming pool in Austin, TX. Enjoy modern amenities and a vibrant lifestyle at Hangar at Bergstrom.",
      "page_copy": "If you're seeking an oasis in Austin, TX, check out our apartments with swimming pool features at Hangar at Bergstrom. Our community offers a beautiful swimming pool that is perfect for cooling off on hot Texas days. \n\nLocated conveniently in Austin, Hangar at Bergstrom provides residents with access to a ceiling fan and air conditioner in each unit, ensuring comfort year-round. Additionally, every apartment includes a refrigerator, adding convenience to your daily living. Discover the ideal blend of leisure and luxury at our community, where the swimming pool is just one of many outstanding amenities to enhance your lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Swimming Pool in Austin, TX",
      "seo_description": "Discover apartments in Austin, TX with a swimming pool at Hangar at Bergstrom. Enjoy top amenities and a vibrant community lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-travis-county",
      "search_query": "air conditioned apartments Travis County",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Travis County",
      "h2_subtitle": "Discover air conditioned apartments in Travis County at Hangar at Bergstrom. Experience year-round comfort in our modern living spaces.",
      "page_copy": "Hangar at Bergstrom offers the ultimate in comfort with air conditioned apartments in Travis County, Austin, TX. Our units are thoughtfully equipped with modern air conditioning systems, ensuring that you stay cool and comfortable no matter the season. \n\nNestled in a vibrant community, our apartments not only provide air conditioning but also feature a ceiling fan for added airflow. Residents can enjoy other amenities such as a sparkling swimming pool and a refrigerator in every apartment. Embrace a stress-free lifestyle, combining convenience and comfort as part of the welcoming community at Hangar at Bergstrom.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Travis County, TX",
      "seo_description": "Find air conditioned apartments in Travis County at Hangar at Bergstrom, offering modern comfort and convenience in a prime Austin location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "generator",
      "page_item_url": "ceiling-fan-apartments-near-78744-austin",
      "search_query": "ceiling fan apartments near 78744",
      "category": "Amenity",
      "h1_title": "Ceiling Fan Apartments Near 78744",
      "h2_subtitle": "Find apartments with ceiling fans near 78744 at Hangar at Bergstrom. Enjoy enhanced comfort and a convenient location in Austin.",
      "page_copy": "Discover the perfect place to call home at Hangar at Bergstrom, where our apartments near 78744 come equipped with ceiling fans to keep you comfortable in every season. Ceiling fans are an energy-efficient way to stay cool, complementing our modern air conditioners perfectly.\n\nIn addition to ceiling fans, residents enjoy a host of amenities including a refreshing swimming pool and in-unit refrigerators, making daily life more enjoyable. Located in Austin's dynamic Travis County, Hangar at Bergstrom offers an ideal blend of practicality and comfort in a sought-after location.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Ceiling Fan Apartments Near 78744",
      "seo_description": "Explore ceiling fan apartments near 78744 at Hangar at Bergstrom. Enjoy modern amenities in a convenient Austin, TX location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "generator",
      "page_item_url": "apartments-with-refrigerator-austin",
      "search_query": "apartments with refrigerator Austin",
      "category": "Amenity",
      "h1_title": "Apartments with Refrigerator in Austin",
      "h2_subtitle": "Explore Austin apartments with a refrigerator at Hangar at Bergstrom. Offering convenient amenities for modern living.",
      "page_copy": "Hangar at Bergstrom features apartments equipped with a refrigerator in Austin, TX, providing everyday convenience right at your fingertips. Our community ensures that each resident has a fully equipped kitchen, complete with a refrigerator, making meal prep and storage hassle-free.\n\nNestled in the vibrant city of Austin, our property also boasts a selection of great amenities including a swimming pool where you can unwind, air conditioning and ceiling fans for optimal comfort. Designed for convenience and comfort, Hangar at Bergstrom offers an ideal setting for enjoying life in Texas.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Refrigerator in Austin, TX",
      "seo_description": "Find Austin apartments with a refrigerator at Hangar at Bergstrom. Experience modern comfort and convenience with our exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "generator",
      "page_item_url": "luxury-pool-apartments-bergstrom",
      "search_query": "luxury pool apartments Bergstrom",
      "category": "Amenity",
      "h1_title": "Luxury Pool Apartments at Bergstrom",
      "h2_subtitle": "Discover luxury pool apartments at Hangar at Bergstrom in Austin. Enjoy premier amenities and a relaxed atmosphere in our thriving community.",
      "page_copy": "At Hangar at Bergstrom, experience the epitome of luxury with our pool apartments, located conveniently near Bergstrom. Our sparkling swimming pool is a standout feature, offering residents a perfect escape to unwind and enjoy the Texas sunshine in a sophisticated setting.\n\nApartments at Hangar at Bergstrom in Austin are designed with comfort and convenience in mind, boasting modern amenities like air conditioning and ceiling fans to ensure a pleasant living environment. Each apartment includes a refrigerator, enhancing everyday living, while our unparalleled pool area sets the stage for relaxation and recreation.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Pool Apartments at Bergstrom, Austin",
      "seo_description": "Explore luxury pool apartments at Hangar at Bergstrom in Austin. Enjoy top-tier amenities and a prime location near Bergstrom.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-south-austin",
      "search_query": "one bedroom apartments south Austin",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in South Austin",
      "h2_subtitle": "Explore one bedroom apartments in South Austin at Hangar at Bergstrom. Enjoy modern amenities and a vibrant community lifestyle.",
      "page_copy": "Welcome to Hangar at Bergstrom, where our one bedroom apartments in South Austin offer the perfect blend of style and function. Each thoughtfully designed apartment provides spacious layouts and modern comforts, including ceiling fans and air conditioners, ensuring a cool and comfortable home.\n\nSituated conveniently in the lively South Austin area, our community features desirable amenities such as a refreshing swimming pool and well-equipped kitchens with a refrigerator. Embrace the active lifestyle and vibrant culture of South Austin while enjoying the comfort and convenience of our beautifully appointed one bedroom apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in South Austin",
      "seo_description": "Discover one bedroom apartments in South Austin at Hangar at Bergstrom. Enjoy modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-78744",
      "search_query": "two bedroom apartments 78744",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in 78744",
      "h2_subtitle": "Find spacious two bedroom apartments in the 78744 area at Hangar at Bergstrom. Enjoy modern amenities and a vibrant community atmosphere.",
      "page_copy": "Hangar at Bergstrom invites you to discover our spacious two bedroom apartments located in the desirable 78744 area of Austin. These thoughtfully designed homes are perfect for those seeking extra space, each featuring modern essentials like a refrigerator, air conditioning, and ceiling fans.\n\nOur community enhances living with outstanding amenities, including a refreshing swimming pool ideal for relaxation and leisure. Perfectly situated in Austin's 78744 zip code, Hangar at Bergstrom provides a blend of comfort, style, and convenience, making it a prime choice for apartment living in this bustling part of the city.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in 78744, Austin",
      "seo_description": "Explore two bedroom apartments at Hangar at Bergstrom in the 78744 area. Enjoy spacious living and top-tier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "generator",
      "page_item_url": "apartments-near-st-edwards-university-austin",
      "search_query": "apartments close to st edwards university austin",
      "category": "School",
      "h1_title": "Apartments Close to St. Edward's University",
      "h2_subtitle": "Discover stylish apartments close to St. Edward's University at Hangar at Bergstrom. Enjoy convenient access and exceptional amenities.",
      "page_copy": "Looking for apartments close to St. Edward's University? Located in Austin, Hangar at Bergstrom offers ideal accommodations for students and professionals alike. Our community provides easy access to the university, making it a perfect place to balance academic and social life.\n\nEnjoy modern amenities such as a sparkling swimming pool, professional air conditioning, and fully equipped kitchens with refrigerators. These features, along with our proximity to St. Edward's University, make Hangar at Bergstrom a top choice for those seeking a vibrant and convenient living experience in Austin.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near St. Edward's University, Austin",
      "seo_description": "Explore Hangar at Bergstrom for apartments close to St. Edward's University. Enjoy modern amenities and easy access to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "generator",
      "page_item_url": "apartments-near-austin-community-college-riverside",
      "search_query": "apartments near austin community college riverside",
      "category": "School",
      "h1_title": "Apartments Near ACC Riverside",
      "h2_subtitle": "Find ideal apartments near Austin Community College Riverside at Hangar at Bergstrom. Experience a vibrant community and unparalleled amenities.",
      "page_copy": "Searching for apartments near Austin Community College Riverside? Hangar at Bergstrom provides an excellent living option for students and staff. Our location offers seamless access to the college, making commutes simple and efficient.\n\nOur community boasts exceptional amenities, including cooling ceiling fans and air conditioning, perfect for the Texas heat. Residents also enjoy a refreshing swimming pool, ideal for relaxation and socializing. Choose Hangar at Bergstrom for a convenient and comfortable apartment living experience next to Austin Community College Riverside.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Austin Community College Riverside",
      "seo_description": "Discover Hangar at Bergstrom, offering apartments near ACC Riverside with modern amenities and convenient college access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "generator",
      "page_item_url": "apartment-homes-near-acc-south-austin-campus",
      "search_query": "apartment homes near acc south austin campus",
      "category": "School",
      "h1_title": "Apartment Homes Near ACC South Austin",
      "h2_subtitle": "Discover comfortable apartment homes near ACC South Austin Campus at Hangar at Bergstrom, featuring excellent amenities and easy access.",
      "page_copy": "Are you looking for apartment homes near ACC South Austin Campus? Consider Hangar at Bergstrom, where convenience meets comfort in apartment living. Our prime location allows for quick, hassle-free commutes to ACC South Austin, ideal for students and faculty.\n\nExperience top-notch amenities, including a sparkling swimming pool and air-conditioned living spaces that promise a comfortable lifestyle. Residents will love the fully-equipped kitchens with refrigerators and the tranquility offered by ceiling fans. Choose Hangar at Bergstrom as your home base while attending ACC South Austin Campus, and enjoy a vibrant community atmosphere.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Homes Near ACC South Austin Campus",
      "seo_description": "Hangar at Bergstrom offers apartment homes near ACC South Austin with top amenities and easy access to campus life.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "generator",
      "page_item_url": "apartments-close-to-huston-tillotson-university-austin",
      "search_query": "apartments close to huston tillotson university austin tx",
      "category": "School",
      "h1_title": "Apartments Close to Huston-Tillotson University",
      "h2_subtitle": "Explore apartments close to Huston-Tillotson University at Hangar at Bergstrom. Enjoy convenient access and top-notch amenities in Austin, TX.",
      "page_copy": "For those seeking apartments close to Huston-Tillotson University, Hangar at Bergstrom offers a prime Austin location. Our community provides easy access to the university, making it an ideal choice for students and university staff.\n\nResidents can enjoy modern comforts such as ceiling fans and efficient air conditioning, perfect for Austin's warm climate. Additionally, our refreshing swimming pool and fully equipped kitchens with refrigerators enhance the living experience. By choosing Hangar at Bergstrom, you'll enjoy both proximity to Huston-Tillotson University and a community rich with amenities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Huston-Tillotson University Austin TX",
      "seo_description": "Find apartments close to Huston-Tillotson University in Austin, TX. Hangar at Bergstrom offers convenient access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "generator",
      "page_item_url": "apartments-near-st-davids-south-austin-medical-center",
      "search_query": "apartments near st david's south austin medical center travis county",
      "category": "Hospital",
      "h1_title": "Apartments Near St. David's South Austin",
      "h2_subtitle": "Find ideal apartments near St. David's South Austin Medical Center in Travis County at Hangar at Bergstrom, featuring top amenities and a convenient location.",
      "page_copy": "If you're looking for apartments near St. David's South Austin Medical Center in Travis County, consider Hangar at Bergstrom. Our community is perfectly situated to offer a quick commute to the medical center, making it an excellent option for healthcare professionals and those needing easy access.\n\nHangar at Bergstrom provides residents with excellent amenities, including an inviting swimming pool and air conditioning to beat the Austin heat. Enjoy modern conveniences like kitchen refrigerators and ceiling fans that enhance comfort. Experience a balance of accessibility and a comfortable lifestyle by choosing our community near St. David's.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near St. David's South Austin Medical Center",
      "seo_description": "Discover convenient living at Hangar at Bergstrom with apartments near St. David's South Austin Medical Center, Travis County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "generator",
      "page_item_url": "apartments-near-mckinney-falls-state-park-austin",
      "search_query": "apartments near mckinney falls state park austin",
      "category": "Park",
      "h1_title": "Apartments Near McKinney Falls State Park",
      "h2_subtitle": "Explore apartments near McKinney Falls State Park in Austin at Hangar at Bergstrom, where nature and modern living meet.",
      "page_copy": "Looking for apartments near McKinney Falls State Park in Austin? Hangar at Bergstrom offers a convenient location close to this beautiful outdoor oasis. Enjoy easy access to hiking, picnicking, and the natural beauty of the park.\n\nOur community provides residents with wonderful amenities such as a refreshing swimming pool and climate-controlled air conditioning. Each apartment comes equipped with a refrigerator and ceiling fans for added comfort. Experience the best of outdoor activities and modern living by choosing Hangar at Bergstrom as your home base near McKinney Falls State Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near McKinney Falls State Park Austin",
      "seo_description": "Live near nature at Hangar at Bergstrom, offering apartments close to McKinney Falls State Park in Austin with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "generator",
      "page_item_url": "hangar-at-bergstrom-close-to-auditorium-shores-tx",
      "search_query": "hangar at bergstrom close to auditorium shores tx",
      "category": "Park",
      "h1_title": "Hangar at Bergstrom Near Auditorium Shores",
      "h2_subtitle": "Discover Hangar at Bergstrom, conveniently close to Auditorium Shores, TX. Enjoy the vibrant lifestyle that our Austin location offers.",
      "page_copy": "Hangar at Bergstrom is ideally located for those who desire proximity to Auditorium Shores, TX. Experience all the cultural and recreational activities this vibrant area of Austin offers while enjoying a comfortable living environment.\n\nOur community boasts fantastic amenities such as a cooling swimming pool and efficient air conditioning, perfect for Texas summers. Inside, you'll find conveniences like ceiling fans and refrigerators in each apartment. Hangar at Bergstrom provides an ideal home base with easy access to the lively events and scenic views found at Auditorium Shores.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hangar at Bergstrom Near Auditorium Shores TX",
      "seo_description": "Stay close to Auditorium Shores, TX at Hangar at Bergstrom. Enjoy great amenities and a prime Austin location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "generator",
      "page_item_url": "apartments-by-boardwalk-lady-bird-lake-78744",
      "search_query": "apartments by the boardwalk at lady bird lake 78744",
      "category": "Park",
      "h1_title": "Apartments by Boardwalk at Lady Bird Lake",
      "h2_subtitle": "Experience life at the apartments by the Boardwalk at Lady Bird Lake in the 78744 area, at Hangar at Bergstrom.",
      "page_copy": "For those seeking a picturesque living experience, Hangar at Bergstrom offers apartments by the Boardwalk at Lady Bird Lake in the 78744 area of Austin. Our location provides easy access to the scenic views and outdoor activities available along the Boardwalk.\n\nThe community includes desirable amenities such as a sparkling swimming pool and efficient air conditioning. Each residence is equipped with modern conveniences like a refrigerator and ceiling fans. Enjoy both a relaxing lifestyle and the convenience of city amenities by making Hangar at Bergstrom your home near Lady Bird Lake.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Boardwalk at Lady Bird Lake 78744",
      "seo_description": "Live near the Boardwalk at Lady Bird Lake with apartments in the 78744 area. Hangar at Bergstrom offers great amenities and access to Austin's outdoors.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "generator",
      "page_item_url": "hangar-at-bergstrom-near-lady-bird-lake-hike-bike-trail",
      "search_query": "hangar at bergstrom near lady bird lake hike & bike trail travis county",
      "category": "Park",
      "h1_title": "Hangar at Bergstrom Near Lady Bird Lake Trail",
      "h2_subtitle": "Discover Hangar at Bergstrom, conveniently near the Lady Bird Lake Hike & Bike Trail in Travis County, Austin.",
      "page_copy": "Situated near the Lady Bird Lake Hike & Bike Trail in Travis County, Hangar at Bergstrom offers a blend of modern convenience and outdoor lifestyle. Just a short distance from the lake, our residents enjoy easy access to miles of scenic trails perfect for biking, walking, or running.\n\nWith amenities including a refreshing swimming pool and air-conditioned comfort, our community is designed for relaxation after a day on the trail. Each apartment features a refrigerator and ceiling fan, providing a comfortable and refreshing living experience. Choose Hangar at Bergstrom for proximity to nature and the vibrant Austin lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hangar at Bergstrom Near Lady Bird Lake Trail",
      "seo_description": "Live close to the Lady Bird Lake Hike & Bike Trail at Hangar at Bergstrom in Travis County. Enjoy modern living with great amenities and trail access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "generator",
      "page_item_url": "apartments-near-austin-bergstrom-international-airport",
      "search_query": "apartments near Austin-Bergstrom International Airport",
      "category": "Transit",
      "h1_title": "Apartments Near Austin-Bergstrom Airport",
      "h2_subtitle": "Find the perfect home in our apartments near Austin-Bergstrom International Airport, offering convenience and modern comforts.",
      "page_copy": "Hangar at Bergstrom offers a superb living experience with its location conveniently near Austin-Bergstrom International Airport. This makes our community the perfect choice for frequent flyers and aviation professionals seeking streamlined travel.\n\nEnjoy our amenities like a sparkling swimming pool and state-of-the-art air conditioning, ensuring comfort during Texas summers. Each apartment is equipped with a refrigerator and ceiling fan, adding convenience to everyday living. With easy airport access and a variety of top-notch amenities, Hangar at Bergstrom is the ideal home base in Austin.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Austin-Bergstrom International Airport",
      "seo_description": "Locate your home at Hangar at Bergstrom near Austin-Bergstrom International Airport featuring modern conveniences and excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167663",
      "source": "generator",
      "page_item_url": "apartments-close-to-plaza-saltillo-station-austin",
      "search_query": "apartments close to Plaza Saltillo Station Austin",
      "category": "Transit",
      "h1_title": "Apartments Close to Plaza Saltillo Station",
      "h2_subtitle": "Explore our apartments close to Plaza Saltillo Station in Austin, perfect for convenient commuting and urban living.",
      "page_copy": "Nestled in Austin, Hangar at Bergstrom provides an excellent living choice with its proximity to Plaza Saltillo Station, ideal for those who value easy commuting. Residents can enjoy a seamless connection to Downtown Austin's vibrant scene and all its offerings.\n\nOur community not only offers convenient access to public transport but also features an array of amenities such as a refreshing swimming pool and efficient air conditioning. Apartments come equipped with modern essentials like a refrigerator and ceiling fan. Choose Hangar at Bergstrom for a blend of accessibility and comfort in Austin.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Plaza Saltillo Station Austin",
      "seo_description": "Discover Hangar at Bergstrom's perfect location close to Plaza Saltillo Station in Austin and enjoy modern amenities with great commuting options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "brianna@repli360.com"
    },
    {
      "ID": "custom_gbp_utm",
      "type": "STRING",
      "value": "https://thehangaratbergstrom.com?utm_source=Google_Business-Profile"
    },
    {
      "ID": "custom_sem_utm",
      "type": "STRING",
      "value": "https://thehangaratbergstrom.com?Repli=ppc"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12795355182"
    },
    {
      "ID": "custom_website_utm",
      "type": "STRING",
      "value": "https://thehangaratbergstrom.com?utm_source=propertywebsite"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PSBBPKNH"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "NoHo"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "57313859383"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/1ywy8gqyvq0"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "410fa3d2-d50d-11f0-bf74-cb7f018462a2"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bcd1707-74a8-4db5-b1de-bca46b2e676e"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "888-988-7502"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjFQOWNrL0o4VlluYXhJVjRWUVBkQXc9PSIsInZhbHVlIjoiVllLSk1MdFltRDhmVllaZVRjUERrQT09IiwibWFjIjoiYWYxZDdmOGM5YjA5Y2VhZGY0YjllYjdhYTIyNzdiNzdmNWIzMDliYjk4Mzg4ZjY4OTUyZTU5ZWE4OWZhOTkzOSJ9"
    }
  ],
  "custom_csm": "brianna@repli360.com",
  "custom_gbp_utm": "https://thehangaratbergstrom.com?utm_source=Google_Business-Profile",
  "custom_sem_utm": "https://thehangaratbergstrom.com?Repli=ppc",
  "custom_repli_id": "12795355182",
  "custom_website_utm": "https://thehangaratbergstrom.com?utm_source=propertywebsite",
  "custom_google_gtm_id": "GTM-PSBBPKNH",
  "custom_rollout_phase": "Phase 1",
  "custom_vibesites_theme": "NoHo",
  "custom_ads_subscription": "essential",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "57313859383",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/1ywy8gqyvq0",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "410fa3d2-d50d-11f0-bf74-cb7f018462a2",
  "custom_eliseai_organization_id": "4bcd1707-74a8-4db5-b1de-bca46b2e676e",
  "custom_ppc_tracking_phone_number": "888-988-7502",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjFQOWNrL0o4VlluYXhJVjRWUVBkQXc9PSIsInZhbHVlIjoiVllLSk1MdFltRDhmVllaZVRjUERrQT09IiwibWFjIjoiYWYxZDdmOGM5YjA5Y2VhZGY0YjllYjdhYTIyNzdiNzdmNWIzMDliYjk4Mzg4ZjY4OTUyZTU5ZWE4OWZhOTkzOSJ9"
};

export const generatedAt = '2026-10-06T21:26:26.489Z';
